import React from "react";
import { useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Menu from "@mui/material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import {
  Box, Button, Card, CardContent, CircularProgress, FormControl, IconButton,
  InputLabel, MenuItem, Modal, Select, SelectChangeEvent, TextField, Tooltip, Typography,
  Chip, Switch, FormControlLabel, ToggleButton, ToggleButtonGroup, Divider, Checkbox,
} from "@mui/material";
import { CATALOGO_VISTAS, CATALOGO_TIPOS_POR_VISTA, CATALOGO_SECCIONES, CATALOGO_TITULOS_MARQUEE, PIXELAJE_POR_VISTA_TIPO, CATALOGO_TIPO_VISTA, CATALOGO_SECCION_BANNER, CATALOGO_ORDEN_DISTRIBUCION } from "../../../hooks/catalogosEstaticos/catalogosBanner";
import { useCatalogosBanners, TipoAplicacion, TipoBanner, FormatoBanner, TipoVistaBanner, TituloMarquee } from "../../../hooks/catalogosBanners/catalogosbanners";
import NavBar from "../../../components/navbar/navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AndroidIcon from "@mui/icons-material/Android";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditNoteIcon from "@mui/icons-material/EditNote";
import styled from "@emotion/styled";
import {
  MaterialReactTable,
  MRT_ColumnDef,
  useMaterialReactTable,
} from "material-react-table";
import { useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import {
  CmsBanner,
  CmsBannerRequest,
  CmsBannerDist,
  CmsBannerDistRequest,
  CmsEmpresa,
  CmsRegion,
  CmsEstado,
  CmsPuesto,
} from "./types";

import { API_URL, sentActionLog, verify } from "../../../utils/common";
import VistaPreviaBanner from "../../../components/ModalesAdminBanners/vistaPreviaBanner";
import ModalErroresImagenes from "../../../components/ModalesAdminBanners/modalErroresImagenes";
import ModalErroresVideos from "../../../components/ModalesAdminBanners/modalErroresImagenes";
import { validarPixelesImagen, type ResultadoValidacionPixeles, } from "../../../components/reglasImagenes/reglasPixelesImagenes";
import { validarVideoCompleto, type ResultadoValidacionVideo, } from "../../../components/reglasImagenes/reglasPixelesVideo";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

type Platform = "web" | "ios" | "android";

interface ConfiguracionBannerMultiple {
  tipoAplicacion: string;
  tipo: string;
  formato: string;
  tipoVista: string;
  seccion: string;
}

const CmsAdmin: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const usuario = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  }, []);

  const permisosCms = usuario?.cmsProfile?.permisos ?? [];

  const tienePermiso = React.useCallback(
    (nombre: string, sufijo: string) => {
      return permisosCms.some(
        (permiso: any) =>
          permiso.nombre?.trim().toUpperCase() ===
          nombre.trim().toUpperCase() &&
          permiso.sufijo?.trim().toUpperCase() ===
          sufijo.trim().toUpperCase() &&
          permiso.activo === true
      );
    },
    [permisosCms]
  );

  const puedeAgregarBanner = tienePermiso("agregar_banner", "BANNER");
  const puedeEditarBanner = tienePermiso("editar_banner", "BANNER");
  const puedeEliminarBanner = tienePermiso("eliminar_banner", "BANNER");
  const puedeVistaPrevia = tienePermiso("vista_previa", "BANNER");
  const puedeVerFiltros = tienePermiso("ver_filtros", "BANNER");
  const puedeVerTablaBanners = tienePermiso("ver_tabla_banners", "BANNER");
  const puedeAgregarDistribucion = tienePermiso("agregar_distribucion", "BANNER");
  const puedeEditarDistribucion = tienePermiso("editar_distribucion", "BANNER");
  const puedeOrdenar = tienePermiso("ordenar_distribucion", "BANNER");


  // modal de vista previa 
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);

  // carga de espera en modal de editar 
  const [catalogosCargados, setCatalogosCargados] = React.useState(false);

  //iconos nuevos 
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = React.useState<CmsBanner | null>(null);
  const [allData, setAllData] = React.useState<CmsBanner[]>([]);
  const [data, setData] = React.useState<CmsBanner[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [tipoFilter, setTipoFilter] = React.useState<string>("");
  //const [searchQuery, setSearchQuery] = React.useState<string>("");
  const [platform, setPlatform] = React.useState<Platform>("web");
  const [previewBanner, setPreviewBanner] = React.useState<CmsBanner | null>(null);

  const [openBannerDialog, setOpenBannerDialog] = React.useState<boolean>(false);
  const [openDistDialog, setOpenDistDialog] = React.useState<boolean>(false);
  const [editingBanner, setEditingBanner] = React.useState<CmsBanner | null>(null);
  const [editingDist, setEditingDist] = React.useState<CmsBannerDist | null>(null);
  const [selectedBannerId, setSelectedBannerId] = React.useState<number | null>(null);

  const [openOrdenamientoDialog, setOpenOrdenamientoDialog] = React.useState<boolean>(false);
  const [bannerOrdenamiento, setBannerOrdenamiento] = React.useState<CmsBanner | null>(null);
  const [distribucionesSeleccionadas, setDistribucionesSeleccionadas] = React.useState<number[]>([]);
  const [modoIntercambioOrden, setModoIntercambioOrden] = React.useState<boolean>(false);
  const [ordenDisponibleSeleccionado, setOrdenDisponibleSeleccionado] = React.useState<number | null>(null);

  const [itemsOrdenamiento, setItemsOrdenamiento] = React.useState<any[]>([]);
  const [itemsOrdenamientoGuardados, setItemsOrdenamientoGuardados] = React.useState<any[]>([]);
  const [indiceArrastrado, setIndiceArrastrado] = React.useState<number | null>(null);

  const [empresas, setEmpresas] = React.useState<CmsEmpresa[]>([]);
  const [regiones, setRegiones] = React.useState<CmsRegion[]>([]);
  const [estados, setEstados] = React.useState<CmsEstado[]>([]);
  const [puestos, setPuestos] = React.useState<CmsPuesto[]>([]);
  const [file, setFile] = React.useState<File | undefined>(undefined);
  const [imageDimensions, setImageDimensions] = React.useState<{ width: number, height: number } | null>(null);
  const [isSaving, setIsSaving] = React.useState<boolean>(false);

  // MODAL ERROR DIMENSIONES DE IMAGEN

  const [openErrorImagen, setOpenErrorImagen] = React.useState(false);

  const [resultadoErrorImagen, setResultadoErrorImagen] =
    React.useState<ResultadoValidacionPixeles | null>(null);

  // iconos y opciones 
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, banner: CmsBanner) => { setMenuAnchorEl(event.currentTarget); setSelectedRow(banner); };
  const handleCloseMenu = () => { setMenuAnchorEl(null); setSelectedRow(null); };
  // busqueda 
  const [searchQuery, setSearchQuery] = useState("");
  // filtro por fechas 
  const [fechaFilter, setFechaFilter] = useState("");
  const [vistaFilter, setVistaFilter] = React.useState("");

  const [bannerForm, setBannerForm] = React.useState<CmsBannerRequest>({
    titulo: "",
    descripcion: "",
    tipo: "",
    tipoVista: "",
    formato: "",
    seccion: "",
    tipoAplicacion: "",
    urlRedirect: "",
    urlBanner: "",
    urlView: "",
    activo: true,
  });


  // REGISTRO MULTIPLE DE BANNERS

  const configuracionBannerVacia = (): ConfiguracionBannerMultiple => ({
    tipoAplicacion: "",
    tipo: "",
    formato: "",
    tipoVista: "",
    seccion: "",
  });

  const [registroMultiple, setRegistroMultiple] = React.useState<boolean>(false);
  const [configuracionesBanner, setConfiguracionesBanner] = React.useState<ConfiguracionBannerMultiple[]>([configuracionBannerVacia(),]);
  const [indiceConfiguracion, setIndiceConfiguracion] = React.useState<number>(0);
  const configuracionActual = configuracionesBanner[indiceConfiguracion];

  const tipoAplicacionActual = registroMultiple
    ? configuracionActual?.tipoAplicacion ?? ""
    : bannerForm.tipoAplicacion;

  const tipoActual = registroMultiple
    ? configuracionActual?.tipo ?? ""
    : bannerForm.tipo;

  const formatoMaestro =
    registroMultiple
      ? configuracionesBanner[0]?.formato ?? ""
      : bannerForm.formato;

  const esFormatoMaestroTexto =
    formatoMaestro.trim().toUpperCase() === "TEXTO";

  const actualizarConfiguracionActual = (
    cambios: Partial<ConfiguracionBannerMultiple>
  ) => {
    setConfiguracionesBanner((prev) =>
      prev.map((configuracion, index) =>
        index === indiceConfiguracion
          ? {
            ...configuracion,
            ...cambios,
          }
          : configuracion
      )
    );
  };

  const agregarConfiguracionBanner = () => {
    const formatoPrincipal =
      configuracionesBanner[0]?.formato ?? "";

    setConfiguracionesBanner((prev) => [
      ...prev,
      {
        ...configuracionBannerVacia(),
        formato: formatoPrincipal,
      },
    ]);

    setIndiceConfiguracion(configuracionesBanner.length);
  };

  const eliminarConfiguracionBanner = () => {
    if (configuracionesBanner.length === 1) {
      return;
    }

    setConfiguracionesBanner((prev) =>
      prev.filter((_, index) => index !== indiceConfiguracion)
    );

    setIndiceConfiguracion((prev) =>
      prev === 0 ? 0 : prev - 1
    );
  };

  const configuracionAnterior = () => {
    setIndiceConfiguracion((prev) =>
      prev > 0 ? prev - 1 : prev
    );
  };

  const configuracionSiguiente = () => {
    setIndiceConfiguracion((prev) =>
      prev < configuracionesBanner.length - 1
        ? prev + 1
        : prev
    );
  };

  const {
    obtenerTiposAplicacion,
    obtenerTipos,
    obtenerFormatos,
    obtenerTiposVista,
    obtenerTitulosMarquee,

    loadingTiposAplicacion,
    loadingTipos,
    loadingFormatos,
    loadingTiposVista,
    loadingTitulosMarquee,

    errorTiposAplicacion,
    errorTipos,
    errorFormatos,
    errorTiposVista,
    errorTitulosMarquee,
  } = useCatalogosBanners();

  const [catalogoVistas, setCatalogoVistas] = React.useState<TipoAplicacion[]>([]);
  const [catalogoTipos, setCatalogoTipos] = React.useState<TipoBanner[]>([]);
  const [catalogoFormatos, setCatalogoFormatos] = React.useState<FormatoBanner[]>([]);
  const [catalogoTiposVista, setCatalogoTiposVista] = React.useState<TipoVistaBanner[]>([]);
  const [catalogoTitulosMarquee, setCatalogoTitulosMarquee] = React.useState<TituloMarquee[]>([]);

  React.useEffect(() => {

    const cargarVistas = async () => {
      const resultado = await obtenerTiposAplicacion();
      //console.log("CATÁLOGO TIPOS APLICACION:", resultado);
      setCatalogoVistas(resultado);
    };

    cargarVistas();

  }, []);

  React.useEffect(() => {

    const cargarTipos = async () => {

      if (!tipoAplicacionActual) {
        setCatalogoTipos([]);
        return;
      }

      const resultado =
        await obtenerTipos(tipoAplicacionActual);

      setCatalogoTipos(resultado);
    };

    cargarTipos();

  }, [tipoAplicacionActual]);

  React.useEffect(() => {

    const cargarFormatos = async () => {
      const resultado = await obtenerFormatos();
      //console.log("CATÁLOGO FORMATOS:", resultado);
      setCatalogoFormatos(resultado);
    };

    cargarFormatos();

  }, []);


  React.useEffect(() => {

    const cargarTiposVista = async () => {
      const resultado = await obtenerTiposVista();
      //console.log("CATÁLOGO TIPOS VISTA:",resultado);
      setCatalogoTiposVista(resultado);
    };

    cargarTiposVista();

  }, []);

  React.useEffect(() => {

    const cargarTitulosMarquee = async () => {

      const resultado = await obtenerTitulosMarquee();
      //console.log("CATÁLOGO TÍTULOS MARQUEE:",resultado);
      setCatalogoTitulosMarquee(resultado);
    };

    cargarTitulosMarquee();

  }, []);


  // CATALOGO DINAMICO DE TIPOS
  const tiposDisponibles = catalogoTipos;

  const esTextoMarquee =
    (!registroMultiple ||
      configuracionesBanner[0]?.formato?.trim().toUpperCase() === "TEXTO") &&
    tipoAplicacionActual.trim().toUpperCase() === "MI CUENTA" &&
    tipoActual.trim().toUpperCase() === "TEXTOS MARQUEE";

  const formatosDisponibles = esTextoMarquee
    ? catalogoFormatos.filter(
      (formato) =>
        formato.nombre.trim().toUpperCase() === "TEXTO"
    )
    : catalogoFormatos.filter(
      (formato) =>
        formato.nombre.trim().toUpperCase() !== "TEXTO"
    );



  const tipoSeleccionado = catalogoTipos.find(
    (tipo) =>
      tipo.nombre.trim().toUpperCase() ===
      tipoActual.trim().toUpperCase()
  );

  const pixelajeSeleccionado =
    tipoSeleccionado?.pixelaje ?? null;

  const [distForm, setDistForm] = React.useState<CmsBannerDistRequest>({
    idEmpresa: null,
    idOficina: null,
    idRegion: null,
    idEstado: null,
    idPuesto: null,
    externo: null,
    redirectBanner: false,
    esVisible: true,
    redirectWeb: false,
    fechaInicio: "",
    fechaFin: "",
    orden: null,
    activo: true,
  });

  const getToken = () => localStorage.getItem("jwt");

  const fetchBanners = async () => {

    setIsLoading(true);

    try {

      const token = getToken();

      const res = await fetch(`${API_URL}/cms/banners`, {
        headers: {
          Authorization: `bearer ${token}`,
        },
        cache: "no-store",
      });

      if (!res.ok) {
        throw new Error(`Error GET banners: ${res.status}`);
      }

      const response = await res.json();

      const bannersOrdenados = [...response].sort(
        (a: CmsBanner, b: CmsBanner) =>
          (ordenTipo[a.tipo] ?? 999) -
          (ordenTipo[b.tipo] ?? 999)
      );

      setAllData(bannersOrdenados);
      setData(bannersOrdenados);

    } catch (error) {

      console.error("ERROR AL CARGAR BANNERS:", error);

    } finally {

      setIsLoading(false);

    }
  };


  const fetchCatalogs = () => {
    const token = getToken();
    Promise.all([
      fetch(`${API_URL}/cms/catalogos/empresas`, { headers: { Authorization: `bearer ${token}` } }).then((r) => r.json()),
      fetch(`${API_URL}/cms/catalogos/regiones`, { headers: { Authorization: `bearer ${token}` } }).then((r) => r.json()),
      fetch(`${API_URL}/cms/catalogos/estados`, { headers: { Authorization: `bearer ${token}` } }).then((r) => r.json()),
      fetch(`${API_URL}/cms/catalogos/puestos`, { headers: { Authorization: `bearer ${token}` } }).then((r) => r.json()),
    ])
      .then(([emp, reg, est, pus]) => {
        //console.log("Empresas:", emp);
        //console.log("Regiones:", reg);
        //console.log("Estados:", est);
        //console.log("Puestos:", pus);
        setEmpresas(emp);
        setRegiones(reg);
        setEstados(est);
        setPuestos(pus);
        setCatalogosCargados(true);
      })
      .catch((err) => console.error(err));
  };

  React.useEffect(() => {
    let filtered = [...allData];

    // Buscar por texto
    if (searchQuery.trim()) {
      const search = searchQuery.toLowerCase();

      filtered = filtered.filter((banner) => {
        return (
          banner.titulo.toLowerCase().includes(search) ||
          banner.descripcion.toLowerCase().includes(search)
        );
      });
    }

    // FILTRAR POR VISTA / TIPO DE APLICACION
    if (vistaFilter) {
      filtered = filtered.filter(
        (banner) =>
          banner.tipoAplicacion?.trim().toUpperCase() ===
          vistaFilter.trim().toUpperCase()
      );
    }

    // Filtrar por tipo
    if (tipoFilter) {
      filtered = filtered.filter(
        (banner) =>
          banner.tipo?.trim().toUpperCase() ===
          tipoFilter.trim().toUpperCase()
      );
    }

    // filtro por fecha
    if (fechaFilter) {
      const hoy = new Date();

      const hoySolo = new Date(
        hoy.getFullYear(),
        hoy.getMonth(),
        hoy.getDate()
      );

      filtered = filtered.filter((banner) => {
        const fechaFin = banner.distribuciones?.[0]?.fechaFin;

        if (!fechaFin) {
          return fechaFilter === "sinFecha";
        }

        const fecha = new Date(fechaFin);

        const fechaSolo = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()
        );

        const diferenciaDias = Math.ceil(
          (fechaSolo.getTime() - hoySolo.getTime()) /
          (1000 * 60 * 60 * 24)
        );

        switch (fechaFilter) {
          case "vigentes":
            return fechaSolo >= hoySolo;

          case "hoy":
            return fechaSolo.getTime() === hoySolo.getTime();

          case "vencidos":
            return fechaSolo < hoySolo;

          case "sinFecha":
            return !fechaFin;

          case "7dias":
            return diferenciaDias >= 0 && diferenciaDias <= 7;

          case "30dias":
            return diferenciaDias >= 0 && diferenciaDias <= 30;

          default:
            return true;
        }
      });
    }

    setData(filtered);

  }, [
    searchQuery,
    vistaFilter,
    tipoFilter,
    fechaFilter,
    allData,
  ]);


  React.useEffect(() => {
    (async () => {
      if (!["/", "/login"].includes(location.pathname)) {
        const currentToken = localStorage.getItem("jwt");
        if (currentToken) {
          const isValid = await verify(currentToken);
          if (!isValid) {
            navigate("/");
          } else {
            const permissions = JSON.parse(localStorage.getItem("user") || "{}");
            if (!permissions?.administrationAccess) navigate("/Home");
          }
        } else {
          navigate("/");
        }
      }
    })();
  }, [location.pathname, navigate]);


  React.useEffect(() => {
    fetchBanners();
    fetchCatalogs();
    sentActionLog("Visit_CmsAdmin", "Entro en la vista Admin CMS");
  }, []);

  const handleSaveBanner = async () => {
    const token = getToken();

    setIsSaving(true);

    try {

      // VALIDAR LIMITE DE BANNERS POR FLUJO
      if (!editingBanner && !registroMultiple) {

        const bannersMismoFlujo = allData.filter(
          (banner) =>
            banner.tipoAplicacion?.trim().toUpperCase() ===
            bannerForm.tipoAplicacion?.trim().toUpperCase() &&

            banner.tipo?.trim().toUpperCase() ===
            bannerForm.tipo?.trim().toUpperCase() &&

            banner.formato?.trim().toUpperCase() ===
            bannerForm.formato?.trim().toUpperCase() &&

            banner.tipoVista?.trim().toUpperCase() ===
            bannerForm.tipoVista?.trim().toUpperCase() &&

            banner.seccion?.trim().toUpperCase() ===
            bannerForm.seccion?.trim().toUpperCase()
        );

        const limiteOrdenes =
          CATALOGO_ORDEN_DISTRIBUCION.length;

        if (bannersMismoFlujo.length >= limiteOrdenes) {

          await swal({
            title: "Límite de banners alcanzado",
            text:
              `Este flujo ya tiene ${limiteOrdenes} banners registrados.\n\n` +
              `Tipo de aplicación: ${bannerForm.tipoAplicacion}\n` +
              `Tipo: ${bannerForm.tipo}\n` +
              `Formato: ${bannerForm.formato}\n` +
              `Tipo de vista: ${bannerForm.tipoVista}\n` +
              `Sección: ${bannerForm.seccion}\n\n` +
              `No es posible registrar más banners en este flujo.`,
            icon: "warning",
          });

          return;
        }
      }

      // 1. SUBIR ARCHIVO UNA SOLA VEZ
      let urlBannerFinal = bannerForm.urlBanner || "";

      if (file?.name) {
        const uniqueName = `${Date.now()}_${file.name}`;

        const data = {
          fileName: uniqueName,
          metadata: {
            title: file.name.split(".")[0],
          },
        };

        // SOLICITAR URL DE CARGA
        const uploadUrlResponse = await fetch(
          `${API_URL}/files/upload/cms-banners`,
          {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              Authorization: `bearer ${token}`,
              "content-type": "application/json",
            },
          }
        );

        const uploadUrlData: { [key: string]: string } =
          await uploadUrlResponse.json();

        if (!uploadUrlResponse.ok) {
          throw new Error(
            "Error al solicitar la URL para subir el archivo"
          );
        }

        const uploadUrl = uploadUrlData[uniqueName];

        if (!uploadUrl) {
          throw new Error(
            "No se recibió URL de upload"
          );
        }

        // SUBIR ARCHIVO A S3
        const uploadResponse = await fetch(uploadUrl, {
          method: "PUT",
          body: file,
          headers: {
            "x-amz-meta-title": file.name.split(".")[0],
          },
        });

        if (!uploadResponse.ok) {
          throw new Error(
            esFormatoVideo
              ? "Error al subir video a S3"
              : "Error al subir imagen a S3"
          );
        }

        urlBannerFinal = `cms/banners/${uniqueName}`;
      }

      // 2. FUNCION PARA HACER POST / PUT DE UN BANNER
      const guardarBannerRequest = async (
        form: CmsBannerRequest,
        endpoint: string,
        method: "POST" | "PUT"
      ): Promise<CmsBanner> => {

        const res = await fetch(endpoint, {
          method,
          body: JSON.stringify(form),
          headers: {
            Authorization: `bearer ${token}`,
            "content-type": "application/json",
          },
        });

        const response = await res.json();
        if (!res.ok) {
          throw new Error(
            response?.message ||
            `Error al guardar banner: ${res.status}`
          );
        }

        return response;
      };

      // 3. CREACION MÚLTIPLE
      if (registroMultiple && !editingBanner) {

        const bannersGuardados: CmsBanner[] = [];

        for (
          let index = 0;
          index < configuracionesBanner.length;
          index++
        ) {
          const configuracion = configuracionesBanner[index];

          // Saber si este registro es TEXTO
          const esTexto =
            configuracion.formato
              ?.trim()
              .toUpperCase() === "TEXTO" ||
            (
              configuracion.tipoAplicacion
                ?.trim()
                .toUpperCase() === "MI CUENTA" &&
              configuracion.tipo
                ?.trim()
                .toUpperCase() === "TEXTOS MARQUEE"
            );

          const form: CmsBannerRequest = {
            ...bannerForm,

            // CAMPOS VARIABLES DE CADA REGISTRO
            tipoAplicacion:
              configuracion.tipoAplicacion,

            tipo:
              configuracion.tipo,

            formato: esTexto
              ? "TEXTO"
              : configuracion.formato,

            tipoVista:
              configuracion.tipoVista,

            seccion:
              configuracion.seccion,

            // CAMPOS COMPARTIDOS
            titulo:
              bannerForm.titulo,

            descripcion:
              bannerForm.descripcion,

            urlBanner: esTexto
              ? ""
              : urlBannerFinal,

            urlRedirect: esTexto
              ? ""
              : bannerForm.urlRedirect,

            urlView:
              bannerForm.urlView,

            activo: true,
          };

          // IMPORTANTE:
          // await hace que se guarden UNO POR UNO
          const responseGuardado =
            await guardarBannerRequest(
              form,
              `${API_URL}/cms/banners`,
              "POST"
            );

          bannersGuardados.push(responseGuardado);
        }

        // ACTUALIZAR TABLA UNA SOLA VEZ
        setAllData((prev) => {

          const idsExistentes =
            new Set(prev.map((banner) => banner.id));

          const nuevos =
            bannersGuardados.filter(
              (banner) =>
                !idsExistentes.has(banner.id)
            );

          return [
            ...nuevos,
            ...prev,
          ];
        });

        // MENSAJE DE EXITO
        swal({
          title: "Creados!",
          text:
            `${bannersGuardados.length} banners ` +
            `guardados correctamente`,
          icon: "success",
        });

        sentActionLog(
          "Create_CmsBanner",
          `Creo ${bannersGuardados.length} Banners CMS`
        );

      } else {

        // 4. CREACION NORMAL / EDICION
        const esTexto =
          bannerForm.formato
            ?.trim()
            .toUpperCase() === "TEXTO" ||
          (
            bannerForm.tipoAplicacion
              ?.trim()
              .toUpperCase() === "MI CUENTA" &&
            bannerForm.tipo
              ?.trim()
              .toUpperCase() === "TEXTOS MARQUEE"
          );

        const form: CmsBannerRequest = {
          ...bannerForm,

          formato: esTexto
            ? "TEXTO"
            : bannerForm.formato,

          seccion:
            bannerForm.seccion,

          urlBanner: esTexto
            ? ""
            : urlBannerFinal,

          urlRedirect: esTexto
            ? ""
            : bannerForm.urlRedirect,

          activo: true,
        };

        const method: "POST" | "PUT" =
          editingBanner
            ? "PUT"
            : "POST";

        const endpoint =
          editingBanner
            ? `${API_URL}/cms/banners/${editingBanner.id}`
            : `${API_URL}/cms/banners`;

        const responseGuardado =
          await guardarBannerRequest(
            form,
            endpoint,
            method
          );


        // ACTUALIZAR TABLA
        if (editingBanner) {

          setAllData((prev) =>
            prev.map((banner) => {

              if (
                banner.id !== responseGuardado.id
              ) {
                return banner;
              }

              return {
                ...banner,
                ...responseGuardado,

                distribuciones:
                  responseGuardado
                    .distribuciones?.length
                    ? responseGuardado.distribuciones
                    : banner.distribuciones,
              };
            })
          );

        } else {

          setAllData((prev) => {

            const yaExiste =
              prev.some(
                (banner) =>
                  banner.id ===
                  responseGuardado.id
              );

            if (yaExiste) {
              return prev;
            }

            return [
              responseGuardado,
              ...prev,
            ];
          });
        }

        // MENSAJE NORMAL
        swal({
          title: editingBanner
            ? "Actualizado!"
            : "Creado!",
          text:
            "Banner guardado correctamente",
          icon: "success",
        });

        sentActionLog(
          editingBanner
            ? "Edit_CmsBanner"
            : "Create_CmsBanner",

          `${editingBanner
            ? "Edito"
            : "Creo"
          } un Banner CMS`
        );
      }

      // 5. LIMPIAR MODAL
      // SOLO LLEGAMOS AQUI SI TODO TERMINO CORRECTAMENTE

      setOpenBannerDialog(false);
      setEditingBanner(null);

      setRegistroMultiple(false);
      setConfiguracionesBanner([
        configuracionBannerVacia(),
      ]);
      setIndiceConfiguracion(0);

      setFile(undefined);
      setImageDimensions(null);

      setVideoDimensions(null);
      setVideoDuration(null);

      resetBannerForm();

    } catch (err) {

      console.error(
        "ERROR AL GUARDAR BANNER:",
        err
      );

      swal({
        title: "Error",
        text:
          err instanceof Error
            ? err.message
            : JSON.stringify(err),
        icon: "error",
      });

    } finally {

      setIsSaving(false);

    }
  };

  const handleDeleteBanner = (id: number) => {
    swal({ title: "¿Eliminar banner?", text: "Esta acción no se puede deshacer", icon: "warning", buttons: [true, true], dangerMode: true }).then((willDelete) => {
      if (willDelete) {
        const token = getToken();
        fetch(`${API_URL}/cms/banners/${id}`, {
          method: "DELETE",
          headers: { Authorization: `bearer ${token}` },
        })
          .then((res) => res.json())
          .then(() => {
            swal({ title: "Eliminado!", text: "Banner eliminado correctamente", icon: "success" });
            fetchBanners();
            sentActionLog("Delete_CmsBanner", `Elimino un Banner CMS id=${id}`);
          })
          .catch((err) => console.error(err));
      }
    });
  };

  const handleToggleActivo = (id: number, activo: boolean) => {
    const token = getToken();
    fetch(`${API_URL}/cms/banners/${id}/activo`, {
      method: "PATCH",
      body: JSON.stringify({ activo }),
      headers: { Authorization: `bearer ${token}`, "content-type": "application/json" },
    })
      .then((res) => res.json())
      .then(() => fetchBanners())
      .catch((err) => console.error(err));
  };

  const fechasDistribucionValidas =
    distForm.fechaInicio !== "" &&
    distForm.fechaFin !== "" &&
    new Date(distForm.fechaFin).getTime() >
    new Date(distForm.fechaInicio).getTime();


  const obtenerConflictoOrden = () => {
    if (!selectedBannerId) return null;

    const bannerActual = allData.find(
      (banner) => banner.id === selectedBannerId
    );

    if (!bannerActual) return null;

    for (const banner of allData) {
      const mismaConfiguracion =
        banner.tipo?.trim().toUpperCase() ===
        bannerActual.tipo?.trim().toUpperCase() &&
        banner.tipoVista?.trim().toUpperCase() ===
        bannerActual.tipoVista?.trim().toUpperCase() &&
        banner.formato?.trim().toUpperCase() ===
        bannerActual.formato?.trim().toUpperCase() &&
        banner.tipoAplicacion?.trim().toUpperCase() ===
        bannerActual.tipoAplicacion?.trim().toUpperCase() &&
        banner.seccion?.trim().toUpperCase() ===
        bannerActual.seccion?.trim().toUpperCase();

      if (!mismaConfiguracion) {
        continue;
      }

      const distribucionConflicto = banner.distribuciones?.find((dist) => {
        // Si estamos editando, ignoramos la misma distribución
        if (editingDist && dist.id === editingDist.id) {
          return false;
        }

        return (
          dist.activo === true &&
          Number(dist.orden) === Number(distForm.orden)
        );
      });

      if (distribucionConflicto) {
        return {
          orden: distribucionConflicto.orden,
          tipo: bannerActual.tipo,
          titulo: banner.titulo,
          tipoVista: bannerActual.tipoVista,
          formato: bannerActual.formato,
          tipoAplicacion: bannerActual.tipoAplicacion,
          seccion: bannerActual.seccion,
        };
      }
    }

    return null;
  };
  const handleSaveDist = () => {
    if (!selectedBannerId) return;

    /*
const conflictoOrden = obtenerConflictoOrden();

if (conflictoOrden) {
  swal({
    title: "Orden no disponible",
    text:
      `Ya existe una distribución activa con el orden ${conflictoOrden.orden}.\n\n` +
      `Titulo: ${conflictoOrden.titulo}\n` +
      `Tipo: ${conflictoOrden.tipo}\n` +
      `Tipo de vista: ${conflictoOrden.tipoVista}\n` +
      `Formato: ${conflictoOrden.formato}\n` +
      `Tipo aplicación: ${conflictoOrden.tipoAplicacion}\n` +
      `Sección: ${conflictoOrden.seccion}`,
    icon: "warning",
  });

  return;
}
*/

    // Validar que fecha_fin > fecha_inicio
    if (distForm.fechaInicio && distForm.fechaFin) {
      const inicio = new Date(distForm.fechaInicio);
      const fin = new Date(distForm.fechaFin);

      if (fin <= inicio) {
        swal({
          title: "Fechas no válidas",
          text: "La fecha fin debe ser posterior a la fecha inicio.",
          icon: "warning",
        });
        return;
      }
    }

    setIsSaving(true);
    const token = getToken();
    const method = editingDist ? "PUT" : "POST";
    const url = editingDist
      ? `${API_URL}/cms/banners/${selectedBannerId}/distribucion/${editingDist.id}`
      : `${API_URL}/cms/banners/${selectedBannerId}/distribucion`;

    fetch(url, {
      method,
      body: JSON.stringify(distForm),
      headers: { Authorization: `bearer ${token}`, "content-type": "application/json" },
    })
      .then((res) => res.json())
      .then(async () => {
        fetchBanners();

        swal({
          title: editingDist ? "Actualizada!" : "Creada!",
          text: "Distribución guardada correctamente",
          icon: "success",
        });
        handleCloseDistDialog();
        // setOpenDistDialog(false);
        //setEditingDist(null);
        //resetDistForm();
      })
      .catch((err) => {
        swal({ title: "Error", text: JSON.stringify(err), icon: "error" });
      })
      .finally(() => setIsSaving(false));
  };

  const handleDeleteDist = (bannerId: number, distId: number) => {
    swal({ title: "¿Eliminar distribución?", icon: "warning", buttons: [true, true], dangerMode: true }).then((willDelete) => {
      if (willDelete) {
        const token = getToken();
        fetch(`${API_URL}/cms/banners/${bannerId}/distribucion/${distId}`, {
          method: "DELETE",
          headers: { Authorization: `bearer ${token}` },
        })
          .then((res) => res.json())
          .then(() => {
            swal({ title: "Eliminada!", text: "Distribución eliminada", icon: "success" });
            fetchBanners();
          })
          .catch((err) => console.error(err));
      }
    });
  };





  const openCreateDist = (bannerId: number) => {
    resetDistForm();
    setEditingDist(null);
    setSelectedBannerId(bannerId);
    setOpenDistDialog(true);
  };

  const openEditDist = (bannerId: number, dist: CmsBannerDist) => {
    setDistForm({
      idEmpresa: dist.idEmpresa,
      idOficina: dist.idOficina,
      idRegion: dist.idRegion,
      idEstado: dist.idEstado,
      idPuesto: dist.idPuesto,
      externo: dist.externo,
      redirectBanner: dist.redirectBanner,
      esVisible: dist.esVisible,
      redirectWeb: dist.redirectWeb,
      fechaInicio: dist.fechaInicio ? dist.fechaInicio.substring(0, 16) : "",
      fechaFin: dist.fechaFin ? dist.fechaFin.substring(0, 16) : "",
      orden: dist.orden,
      activo: dist.activo,
    });
    setEditingDist(dist);
    setSelectedBannerId(bannerId);
    setOpenDistDialog(true);
  };

  const handleCloseDistDialog = () => {
    setOpenDistDialog(false);
    setEditingDist(null);
    setSelectedBannerId(null);
    resetDistForm();

  };

  const openOrdenamiento = (banner: CmsBanner) => {
    setBannerOrdenamiento(banner);

    setModoIntercambioOrden(false);
    setDistribucionesSeleccionadas([]);

    setOpenOrdenamientoDialog(true);
    handleCloseMenu();
  };

  const handleCloseOrdenamiento = () => {
    setOpenOrdenamientoDialog(false);
    setBannerOrdenamiento(null);

    setModoIntercambioOrden(false);
    setDistribucionesSeleccionadas([]);
  };

  const handleSeleccionarDistribucionOrden = (
    distribucionId: number
  ) => {
    setDistribucionesSeleccionadas((prev) => {

      // QUITAR SI YA ESTÁ SELECCIONADO
      if (prev.includes(distribucionId)) {
        return prev.filter(
          (id) => id !== distribucionId
        );
      }

      // MODO INTERCAMBIO:
      // máximo 2 registros
      if (modoIntercambioOrden) {
        if (prev.length >= 2) {
          return prev;
        }

        return [
          ...prev,
          distribucionId,
        ];
      }

      // MODO ASIGNAR ORDEN DISPONIBLE:
      // solamente 1 registro
      return [distribucionId];
    });
  };


  const bannersMismoFlujo = React.useMemo(() => {
    if (!bannerOrdenamiento) {
      return [];
    }

    return allData.filter((banner) => {
      return (
        banner.tipo?.trim().toUpperCase() ===
        bannerOrdenamiento.tipo?.trim().toUpperCase() &&

        banner.tipoVista?.trim().toUpperCase() ===
        bannerOrdenamiento.tipoVista?.trim().toUpperCase() &&

        banner.formato?.trim().toUpperCase() ===
        bannerOrdenamiento.formato?.trim().toUpperCase() &&

        banner.tipoAplicacion?.trim().toUpperCase() ===
        bannerOrdenamiento.tipoAplicacion?.trim().toUpperCase() &&

        banner.seccion?.trim().toUpperCase() ===
        bannerOrdenamiento.seccion?.trim().toUpperCase()
      );
    });
  }, [allData, bannerOrdenamiento]);



  const ordenamientosExistentes = React.useMemo(() => {
    return bannersMismoFlujo
      .flatMap((banner) =>
        (banner.distribuciones ?? []).map((dist) => ({
          bannerId: banner.id,
          titulo: banner.titulo,

          tipoAplicacion: banner.tipoAplicacion,
          tipo: banner.tipo,
          formato: banner.formato,
          tipoVista: banner.tipoVista,
          seccion: banner.seccion,
          urlBanner: banner.urlBanner,
          distribucionId: dist.id,
          orden: dist.orden,
          fechaInicio: dist.fechaInicio,
          fechaFin: dist.fechaFin,
          activo: dist.activo,
        }))
      )
      .sort(
        (a, b) =>
          Number(a.orden ?? 0) -
          Number(b.orden ?? 0)
      );
  }, [bannersMismoFlujo]);

  React.useEffect(() => {
    if (!openOrdenamientoDialog) {
      return;
    }

    setItemsOrdenamiento(ordenamientosExistentes);
    setItemsOrdenamientoGuardados(ordenamientosExistentes);
  }, [openOrdenamientoDialog, ordenamientosExistentes]);

  const moverItemOrdenamiento = (
    indiceOrigen: number,
    indiceDestino: number
  ) => {
    const nuevosItems = [...itemsOrdenamiento];

    const [itemMovido] = nuevosItems.splice(
      indiceOrigen,
      1
    );

    nuevosItems.splice(
      indiceDestino,
      0,
      itemMovido
    );

    // OBTENER ÚNICAMENTE LOS ÓRDENES
    // QUE YA ESTABAN ASIGNADOS
    const ordenesAsignados = itemsOrdenamiento
      .filter(
        (item) =>
          item.orden !== null &&
          item.orden !== undefined &&
          Number(item.orden) > 0
      )
      .map((item) => Number(item.orden))
      .sort((a, b) => a - b);

    let indiceOrden = 0;

    const itemsReordenados = nuevosItems.map((item) => {
      const tieneOrden =
        item.orden !== null &&
        item.orden !== undefined &&
        Number(item.orden) > 0;

      // LOS REGISTROS SIN ORDEN
      // SE MANTIENEN SIN ORDEN
      if (!tieneOrden) {
        return item;
      }

      const nuevoOrden =
        ordenesAsignados[indiceOrden];

      indiceOrden++;

      return {
        ...item,
        orden: nuevoOrden,
      };
    });

    setItemsOrdenamiento(itemsReordenados);

    return itemsReordenados;
  };


  const obtenerCambiosOrdenamiento = (
    nuevosItems: any[]
  ) => {
    return nuevosItems.filter((itemNuevo) => {
      const itemOriginal =
        itemsOrdenamientoGuardados.find(
          (itemGuardado) =>
            itemGuardado.distribucionId ===
            itemNuevo.distribucionId
        );

      if (!itemOriginal) {
        return false;
      }

      return (
        Number(itemOriginal.orden) !==
        Number(itemNuevo.orden)
      );
    });
  };

  const guardarCambiosOrdenamiento = async (
    cambios: any[]
  ) => {
    if (cambios.length === 0) {
      return;
    }

    try {
      setIsSaving(true);

      const token = getToken();

      for (const item of cambios) {
        // BUSCAR EL BANNER COMPLETO
        const banner = allData.find(
          (banner) => banner.id === item.bannerId
        );

        if (!banner) {
          throw new Error(
            `No se encontró el banner ${item.bannerId}.`
          );
        }

        // BUSCAR LA DISTRIBUCION COMPLETA
        const distribucion =
          banner.distribuciones?.find(
            (dist) =>
              dist.id === item.distribucionId
          );

        if (!distribucion) {
          throw new Error(
            `No se encontró la distribución ${item.distribucionId}.`
          );
        }

        // CONSERVAR TODA LA INFORMACION
        // Y MODIFICAR ÚNICAMENTE EL ORDEN
        const payload: CmsBannerDistRequest = {
          idEmpresa: distribucion.idEmpresa,
          idOficina: distribucion.idOficina,
          idRegion: distribucion.idRegion,
          idEstado: distribucion.idEstado,
          idPuesto: distribucion.idPuesto,

          externo: distribucion.externo,

          redirectBanner:
            distribucion.redirectBanner,

          esVisible:
            distribucion.esVisible,

          redirectWeb:
            distribucion.redirectWeb,

          fechaInicio:
            distribucion.fechaInicio,

          fechaFin:
            distribucion.fechaFin,

          // NUEVO ORDEN
          orden: item.orden,

          activo:
            distribucion.activo,
        };

        const response = await fetch(
          `${API_URL}/cms/banners/${item.bannerId}/distribucion/${item.distribucionId}`,
          {
            method: "PUT",
            body: JSON.stringify(payload),
            headers: {
              Authorization: `bearer ${token}`,
              "content-type": "application/json",
            },
          }
        );

        const resultado = await response.json();

        if (!response.ok) {
          throw new Error(
            resultado?.message ||
            `Error al actualizar la distribución ${item.distribucionId}`
          );
        }
      }

      await fetchBanners();

      await swal({
        title: "Orden actualizado",
        text: "El orden de los banners fue actualizado correctamente.",
        icon: "success",
      });

      handleCloseOrdenamiento();

    } catch (error) {
      console.error(
        "ERROR AL ACTUALIZAR ORDEN:",
        error
      );

      // REGRESAR VISUALMENTE AL ORDEN ORIGINAL
      setItemsOrdenamiento(
        itemsOrdenamientoGuardados
      );

      await swal({
        title: "Error",
        text:
          error instanceof Error
            ? error.message
            : "No fue posible actualizar el orden.",
        icon: "error",
      });

    } finally {
      setIsSaving(false);
    }
  };

  const ordenesOcupados = React.useMemo(() => {
    return new Set(
      ordenamientosExistentes
        .filter(
          (item) =>
            item.orden !== null &&
            item.orden !== undefined &&
            Number(item.orden) > 0
        )
        .map((item) => Number(item.orden))
    );
  }, [ordenamientosExistentes]);

  const ordenesDisponibles = React.useMemo(() => {
    return CATALOGO_ORDEN_DISTRIBUCION.filter(
      (orden) => !ordenesOcupados.has(orden)
    );
  }, [ordenesOcupados]);

  const distribucionBannerAbierto = React.useMemo(() => {
    if (!bannerOrdenamiento) {
      return null;
    }

    return ordenamientosExistentes.find(
      (item) =>
        item.bannerId === bannerOrdenamiento.id
    ) ?? null;
  }, [
    ordenamientosExistentes,
    bannerOrdenamiento,
  ]);

  const bannerAbiertoTieneOrden =
    distribucionBannerAbierto?.orden !== null &&
    distribucionBannerAbierto?.orden !== undefined &&
    Number(distribucionBannerAbierto?.orden) > 0;

  const handleAsignarOrden = async (
    item: any,
    nuevoOrden: number
  ) => {
    if (!item || !nuevoOrden) {
      return;
    }

    const confirmar = await swal({
      title: "Asignar orden",
      text:
        `¿Quieres asignar el orden ${nuevoOrden} ` +
        `al banner "${item.titulo ?? ""}"?`,
      icon: "warning",
      buttons: ["Cancelar", "Aceptar"],
    });

    if (!confirmar) {
      return;
    }

    try {
      setIsSaving(true);

      const token = getToken();

      // BUSCAR EL BANNER COMPLETO
      const bannerCompleto = allData.find(
        (banner) =>
          banner.id === item.bannerId
      );

      if (!bannerCompleto) {
        throw new Error(
          "No se encontró el banner."
        );
      }

      // BUSCAR LA DISTRIBUCIÓN COMPLETA
      const distribucionCompleta =
        bannerCompleto.distribuciones?.find(
          (dist) =>
            dist.id === item.distribucionId
        );

      if (!distribucionCompleta) {
        throw new Error(
          "No se encontró la distribución del banner."
        );
      }

      // CONSERVAR TODOS LOS DATOS
      // Y MODIFICAR ÚNICAMENTE EL ORDEN
      const payload: CmsBannerDistRequest = {
        idEmpresa:
          distribucionCompleta.idEmpresa,

        idOficina:
          distribucionCompleta.idOficina,

        idRegion:
          distribucionCompleta.idRegion,

        idEstado:
          distribucionCompleta.idEstado,

        idPuesto:
          distribucionCompleta.idPuesto,

        externo:
          distribucionCompleta.externo,

        redirectBanner:
          distribucionCompleta.redirectBanner,

        esVisible:
          distribucionCompleta.esVisible,

        redirectWeb:
          distribucionCompleta.redirectWeb,

        fechaInicio:
          distribucionCompleta.fechaInicio,

        fechaFin:
          distribucionCompleta.fechaFin,

        // ÚNICO CAMBIO
        orden: nuevoOrden,

        activo:
          distribucionCompleta.activo,
      };

      const response = await fetch(
        `${API_URL}/cms/banners/${item.bannerId}/distribucion/${item.distribucionId}`,
        {
          method: "PUT",
          body: JSON.stringify(payload),
          headers: {
            Authorization: `bearer ${token}`,
            "content-type": "application/json",
          },
        }
      );

      const resultado = await response.json();

      if (!response.ok) {
        throw new Error(
          resultado?.message ||
          `Error al asignar orden: ${response.status}`
        );
      }

      await fetchBanners();

      await swal({
        title: "Orden asignado",
        text:
          `El orden ${nuevoOrden} fue asignado ` +
          `correctamente a "${item.titulo ?? "el banner"}".`,
        icon: "success",
      });

      if (
        document.activeElement instanceof HTMLElement
      ) {
        document.activeElement.blur();
      }

    } catch (error) {
      console.error(
        "ERROR AL ASIGNAR ORDEN:",
        error
      );

      await swal({
        title: "Error",
        text:
          error instanceof Error
            ? error.message
            : "No fue posible asignar el orden.",
        icon: "error",
      });

    } finally {
      setIsSaving(false);
    }
  };

  const handleIntercambiarOrden = async () => {
    if (distribucionesSeleccionadas.length !== 2) {
      return;
    }

    // BUSCAR LOS DOS REGISTROS SELECCIONADOS
    const registroA = ordenamientosExistentes.find(
      (item) =>
        item.distribucionId === distribucionesSeleccionadas[0]
    );

    const registroB = ordenamientosExistentes.find(
      (item) =>
        item.distribucionId === distribucionesSeleccionadas[1]
    );

    if (!registroA || !registroB) {
      swal({
        title: "Error",
        text: "No se encontraron las distribuciones seleccionadas.",
        icon: "error",
      });

      return;
    }

    const ordenA = Number(registroA.orden);
    const ordenB = Number(registroB.orden);

    if (!ordenA || !ordenB) {
      swal({
        title: "Orden no válido",
        text: "Ambos registros deben tener un orden asignado.",
        icon: "warning",
      });

      return;
    }

    const confirmar = await swal({
      title: "Intercambiar orden",
      text:
        `¿Quieres intercambiar los órdenes ${ordenA} y ${ordenB}?`,
      icon: "warning",
      buttons: ["Cancelar", "Aceptar"],
    });

    if (!confirmar) {
      return;
    }

    try {
      setIsSaving(true);

      const token = getToken();

      // BUSCAR LOS BANNERS COMPLETOS
      const bannerA = allData.find(
        (banner) => banner.id === registroA.bannerId
      );

      const bannerB = allData.find(
        (banner) => banner.id === registroB.bannerId
      );

      if (!bannerA || !bannerB) {
        throw new Error(
          "No se encontraron los banners seleccionados."
        );
      }

      // BUSCAR LAS DISTRIBUCIONES COMPLETAS
      const distribucionA = bannerA.distribuciones?.find(
        (dist) => dist.id === registroA.distribucionId
      );

      const distribucionB = bannerB.distribuciones?.find(
        (dist) => dist.id === registroB.distribucionId
      );

      if (!distribucionA || !distribucionB) {
        throw new Error(
          "No se encontraron las distribuciones seleccionadas."
        );
      }

      // PAYLOAD A
      // conserva todos sus datos y recibe el orden de B
      const payloadA: CmsBannerDistRequest = {
        idEmpresa: distribucionA.idEmpresa,
        idOficina: distribucionA.idOficina,
        idRegion: distribucionA.idRegion,
        idEstado: distribucionA.idEstado,
        idPuesto: distribucionA.idPuesto,

        externo: distribucionA.externo,

        redirectBanner:
          distribucionA.redirectBanner,

        esVisible:
          distribucionA.esVisible,

        redirectWeb:
          distribucionA.redirectWeb,

        fechaInicio:
          distribucionA.fechaInicio,

        fechaFin:
          distribucionA.fechaFin,

        // RECIBE ORDEN DE B
        orden: ordenB,

        activo:
          distribucionA.activo,
      };


      // PAYLOAD B
      // conserva todos sus datos y recibe el orden de A
      const payloadB: CmsBannerDistRequest = {
        idEmpresa: distribucionB.idEmpresa,
        idOficina: distribucionB.idOficina,
        idRegion: distribucionB.idRegion,
        idEstado: distribucionB.idEstado,
        idPuesto: distribucionB.idPuesto,

        externo: distribucionB.externo,

        redirectBanner:
          distribucionB.redirectBanner,

        esVisible:
          distribucionB.esVisible,

        redirectWeb:
          distribucionB.redirectWeb,

        fechaInicio:
          distribucionB.fechaInicio,

        fechaFin:
          distribucionB.fechaFin,

        // RECIBE ORDEN DE A
        orden: ordenA,

        activo:
          distribucionB.activo,
      };

      // PRIMER CAMBIO
      const responseA = await fetch(
        `${API_URL}/cms/banners/${registroA.bannerId}/distribucion/${registroA.distribucionId}`,
        {
          method: "PUT",
          body: JSON.stringify(payloadA),
          headers: {
            Authorization: `bearer ${token}`,
            "content-type": "application/json",
          },
        }
      );

      const resultadoA = await responseA.json();

      if (!responseA.ok) {
        throw new Error(
          resultadoA?.message ||
          `Error al actualizar orden ${ordenA}`
        );
      }

      // SEGUNDO CAMBIO
      const responseB = await fetch(
        `${API_URL}/cms/banners/${registroB.bannerId}/distribucion/${registroB.distribucionId}`,
        {
          method: "PUT",
          body: JSON.stringify(payloadB),
          headers: {
            Authorization: `bearer ${token}`,
            "content-type": "application/json",
          },
        }
      );

      const resultadoB = await responseB.json();

      if (!responseB.ok) {
        throw new Error(
          resultadoB?.message ||
          `Error al actualizar orden ${ordenB}`
        );
      }

      // REFRESCAR DATOS
      await fetchBanners();

      // LIMPIAR SELECCION
      setDistribucionesSeleccionadas([]);
      setModoIntercambioOrden(false);

      // MENSAJE DE ÉXITO
      await swal({
        title: "Ordenes intercambiados",
        text:
          `El orden ${ordenA} ahora es ${ordenB} ` +
          `y el orden ${ordenB} ahora es ${ordenA}.`,
        icon: "success",
      });

      // QUITAR EL FOCO DEL BOTON DE SWEETALERT
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      // CERRAR MODAL DE ORDENAMIENTO
      handleCloseOrdenamiento();

    } catch (error) {

      console.error(
        "ERROR AL INTERCAMBIAR ORDEN:",
        error
      );

      swal({
        title: "Error",
        text:
          error instanceof Error
            ? error.message
            : "No fue posible intercambiar los órdenes.",
        icon: "error",
      });

    } finally {
      setIsSaving(false);
    }
  };

  const resetBannerForm = () => {
    setBannerForm({
      titulo: "",
      descripcion: "",
      tipo: "",
      tipoVista: "",
      formato: "",
      seccion: "",
      tipoAplicacion: "",
      urlRedirect: "",
      urlBanner: "",
      urlView: "",
      activo: true,
    });
  };
  const resetDistForm = () => {
    setDistForm({ idEmpresa: null, idOficina: null, idRegion: null, idEstado: null, idPuesto: null, externo: null, redirectBanner: false, esVisible: true, redirectWeb: false, fechaInicio: "", fechaFin: "", orden: null, activo: true });
  };

  // remarcado de busqueda 
  const highlightText = (
    text: string | undefined | null,
    search: string
  ) => {
    if (!text) return "-";
    if (!search.trim()) return text;

    const regex = new RegExp(`(${search})`, "ig");
    const parts = text.split(regex);

    return (
      <>
        {parts.map((part, index) =>
          part.toLowerCase() === search.toLowerCase() ? (
            <Box
              component="span"
              key={index}
              sx={{
                backgroundColor: "#FFEB3B",
                fontWeight: "bold",
                px: 0.3,
                borderRadius: "2px",
              }}
            >
              {part}
            </Box>
          ) : (
            part
          )
        )}
      </>
    );
  };



  const columns = React.useMemo<MRT_ColumnDef<CmsBanner>[]>(
    () => [
      {
        accessorKey: "titulo",
        header: "Título",
        Cell: ({ cell }) =>
          highlightText(cell.getValue<string>(), searchQuery),
      },
      {
        accessorKey: "descripcion",
        header: "Descripción",
        Cell: ({ cell }) =>
          highlightText(cell.getValue<string>(), searchQuery),
      },
      {
        accessorKey: "tipo",
        header: "Tipo",
        Cell: ({ cell }) => (
          <Chip
            label={cell.getValue<string>()}
            size="small"
            variant="outlined"
            sx={{
              color: "#fdfdfd",
              borderColor: "#2f22aa",
              backgroundColor: "#0505a3",
              fontWeight: 400,
            }}
          />
        ),
      },
      {
        accessorKey: "formato",
        header: "Formato",
        Cell: ({ cell }) =>
          highlightText(cell.getValue<string>(), searchQuery),
      },
      {
        id: "imagen",
        header: "Imagen",
        Cell: ({ row }) => {
          const banner = row.original;

          const formato = banner.formato?.trim().toUpperCase();

          // TEXTO O SIN ARCHIVO
          if (formato === "TEXTO" || !banner.urlBanner) {
            return (
              <Box
                sx={{
                  width: 80,
                  height: 50,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  -
                </Typography>
              </Box>
            );
          }

          // VIDEO
          if (formato === "VIDEO") {
            return (
              <Box
                component="video"
                src={banner.urlBanner}
                muted
                playsInline
                preload="metadata"
                onLoadedMetadata={(e) => {
                  const video = e.currentTarget;

                  // Mover ligeramente el video para mostrar
                  // un fotograma en lugar de una pantalla negra
                  if (video.duration > 0) {
                    video.currentTime = Math.min(0.1, video.duration);
                  }
                }}
                sx={{
                  width: 80,
                  height: 50,
                  objectFit: "cover",
                  borderRadius: 1,
                  border: "1px solid #ddd",
                  display: "block",
                }}
              />
            );
          }

          // IMAGEN
          return (
            <Box
              component="img"
              src={banner.urlBanner}
              alt={banner.titulo}
              sx={{
                width: 80,
                height: 50,
                objectFit: "cover",
                borderRadius: 1,
                border: "1px solid #ddd",
              }}
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
          );
        },
      },
      {
        accessorKey: "seccion",
        header: "Sección",
        Cell: ({ cell }) =>
          highlightText(cell.getValue<string>(), searchQuery),
      },
      {
        id: "fechaInicio",
        header: "Fecha inicio",
        Cell: ({ row }) => {
          const fechaInicio =
            row.original.distribuciones?.[0]?.fechaInicio;

          if (!fechaInicio) {
            return "-";
          }

          const fecha = new Date(fechaInicio);

          return (
            <Chip
              label={fecha.toLocaleString("es-MX")}
              size="small"
              sx={{
                backgroundColor: "#1720a2",
                color: "#f7f1f1",
                fontWeight: 500,
              }}
            />
          );
        },
      },
      {
        id: "fechaFin",
        header: "Fecha fin",
        Cell: ({ row }) => {
          const fechaFin = row.original.distribuciones?.[0]?.fechaFin;

          if (!fechaFin) {
            return (
              <Box
                sx={{
                  display: "inline-block",
                  px: 1,
                  py: 0.3,
                  borderRadius: 1,
                  bgcolor: "#ECEFF1",
                  fontWeight: 600,
                }}
              >
                Sin fecha
              </Box>
            );
          }

          const fecha = new Date(fechaFin);
          const hoy = new Date();

          const fechaSolo = new Date(
            fecha.getFullYear(),
            fecha.getMonth(),
            fecha.getDate()
          );

          const hoySolo = new Date(
            hoy.getFullYear(),
            hoy.getMonth(),
            hoy.getDate()
          );

          let bgColor = "#C8E6C9";

          if (fechaSolo.getTime() < hoySolo.getTime()) {
            bgColor = "#FFCDD2";
          } else if (fechaSolo.getTime() === hoySolo.getTime()) {
            bgColor = "#FFF59D";
          }

          return (
            <Box
              sx={{
                display: "inline-block",
                px: 1,
                py: 0.3,
                borderRadius: 1,
                bgcolor: bgColor,
                fontWeight: 600,
              }}
            >
              {fecha.toLocaleString("es-MX")}
            </Box>
          );
        },
      },
    ],
    [searchQuery]
  );


  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      isLoading: false,
    },
    muiCircularProgressProps: {
      size: 45,
      thickness: 4,
    },

    enableFilters: false,
    enableHiding: false,
    enableSorting: false,
    enableColumnActions: false,
    enablePagination: true,
    enableRowActions: true,
    positionActionsColumn: "last",
    enableStickyHeader: false,
    enableStickyFooter: false,
    enableBottomToolbar: true,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 10,
      },
    },
    muiPaginationProps: {
      rowsPerPageOptions: [10, 15, 20],
      showFirstButton: true,
      showLastButton: true,
    },
    localization: MRT_Localization_ES,
    layoutMode: "grid",
    renderToolbarInternalActions: () =>
      puedeAgregarBanner ? (
        <Button
          variant="contained"
          color="secondary"
          startIcon={<AddIcon />}
          onClick={openCreateBanner}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 2,
            fontWeight: 600,
          }}
        >
          Agregar banner
        </Button>
      ) : null,
    renderRowActions: ({ row }) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenMenu(e, row.original)}
      >
        <MoreVertIcon />
      </IconButton>
    ),
    // state: { isLoading },
    muiTableHeadRowProps: { sx: { backgroundColor: "#f5f5f5" } },
    muiTableBodyRowProps: { sx: { backgroundColor: "#f5f5f5" } },
    muiTopToolbarProps: {
      sx: {
        backgroundColor: "#f5f5f5",
        "& .MuiButton-root": {
          backgroundColor: "#F70083",
        },
      },
    },
    muiBottomToolbarProps: {
      sx: {
        "& .Mui-disabled": {
          opacity: 0.35,
        },
        backgroundColor: "#f5f5f5",
        borderTop: "1px solid #ddd",

        "& .MuiTablePagination-root": {
          color: "#333",
        },

        "& .MuiTablePagination-selectLabel": {
          color: "#333",
        },

        "& .MuiTablePagination-displayedRows": {
          color: "#333",
        },

        "& .MuiIconButton-root": {
          color: "#333",
        },

        "& .MuiSvgIcon-root": {
          color: "#333",
        },
      },
    },
  });

  // orden de tabla 
  const ordenTipo: Record<string, number> = {
    urgente: 1,
    noticias: 2,
    banner: 3,
  };


  // CONTADORES POR TIPO SEGÚN VISTA SELECCIONADA

  const contadoresPorTipo = React.useMemo(() => {

    if (!vistaFilter) {
      return [];
    }

    // Obtener únicamente los banners de la vista seleccionada
    const bannersVista = allData.filter(
      (banner) =>
        banner.tipoAplicacion?.trim().toUpperCase() ===
        vistaFilter.trim().toUpperCase()
    );

    // Agrupar por tipo
    const contador = bannersVista.reduce<Record<string, number>>(
      (acc, banner) => {

        const tipo = banner.tipo?.trim();

        if (!tipo) {
          return acc;
        }

        acc[tipo] = (acc[tipo] ?? 0) + 1;

        return acc;
      },
      {}
    );

    // Convertir a la estructura que ya utiliza la UI
    return Object.entries(contador).map(([tipo, cantidad]) => ({
      tipo,
      cantidad,
    }));

  }, [allData, vistaFilter]);

  // Validación del formulario
  const isBannerFormValid =
    bannerForm.titulo.trim() !== "" &&
    bannerForm.descripcion.trim() !== "" &&
    (
      editingBanner
        ? (file !== undefined || bannerForm.urlBanner.trim() !== "")
        : file !== undefined
    );

  const openCreateBanner = () => {
    resetBannerForm();
    setEditingBanner(null);

    // REGISTRO MULTIPLE
    setRegistroMultiple(false);
    setConfiguracionesBanner([
      configuracionBannerVacia(),
    ]);
    setIndiceConfiguracion(0);

    // Limpiar imagen
    setVideoDimensions(null);
    setVideoDuration(null);
    setResultadoErrorVideo(null);

    setOpenBannerDialog(true);
  };


  const handleCloseCreateBannerDialog = () => {
    setOpenBannerDialog(false);
    resetBannerForm();
    setEditingBanner(null);
    setRegistroMultiple(false);
    setConfiguracionesBanner([
      configuracionBannerVacia(),
    ]);
    setIndiceConfiguracion(0);
    setFile(undefined);
    setImageDimensions(null);
  };


  const openEditBanner = (banner: CmsBanner) => {
    //console.log("BANNER EDITAR COMPLETO:", banner);
    //console.log("tipoAplicacion:", banner.tipoAplicacion);
    //console.log("formato:", banner.formato);
    //console.log("tipo:", banner.tipo);
    setRegistroMultiple(false);
    setConfiguracionesBanner([
      configuracionBannerVacia(),
    ]);
    setIndiceConfiguracion(0);
    setFile(undefined);
    setImageDimensions(null);

    setBannerForm({
      titulo: banner.titulo,
      descripcion: banner.descripcion,
      tipo: banner.tipo,
      tipoVista: banner.tipoVista,
      formato:
        banner.tipoAplicacion?.trim().toUpperCase() === "MI CUENTA" &&
          banner.tipo?.trim().toUpperCase() === "TEXTOS MARQUEE"
          ? "TEXTO"
          : banner.formato || "",
      seccion: banner.seccion || "",
      tipoAplicacion: banner.tipoAplicacion || "",
      urlRedirect: banner.urlRedirect || "",
      urlBanner: banner.urlBanner || "",
      urlView: banner.urlView || "",
      activo: banner.activo,
    });

    setEditingBanner(banner);
    setOpenBannerDialog(true);
  };


  const handleCloseEditBannerDialog = () => {
    setOpenBannerDialog(false);
    resetBannerForm();
    setEditingBanner(null);

    setRegistroMultiple(false);
    setConfiguracionesBanner([
      configuracionBannerVacia(),
    ]);
    setIndiceConfiguracion(0);

    setFile(undefined);
    setImageDimensions(null);
    setVideoDimensions(null);
    setVideoDuration(null);
  };

  const isDistFormValid =
    distForm.idEmpresa !== null &&
    //distForm.idRegion !== null &&
    //distForm.idEstado !== null &&
    //distForm.idPuesto !== null &&
    //distForm.externo !== null &&
    distForm.fechaInicio.trim() !== "" &&
    distForm.fechaFin.trim() !== "" &&
    fechasDistribucionValidas;
  // && distForm.orden > 0;

  // VALIDAR IMAGEN SELECCIONADA

  const handleSeleccionarImagen = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedFile = event.target.files?.[0];

    if (!selectedFile) {
      return;
    }

    // CREAR IMAGEN TEMPORAL PARA LEER DIMENSIONES
    const img = new Image();
    const objectUrl = URL.createObjectURL(selectedFile);

    img.onload = () => {
      const anchoImagen = img.naturalWidth;
      const altoImagen = img.naturalHeight;

      /*
      // VALIDACION DE PIXELAJE - DESACTIVADA TEMPORALMENTE
  
      const resultado = validarPixelesImagen(
        anchoImagen,
        altoImagen,
        pixelajeSeleccionado
      );
  
      if (!resultado.valido) {
        // No guardar el archivo incorrecto
        setFile(undefined);
        setImageDimensions(null);
  
        // Guardar información del error
        setResultadoErrorImagen(resultado);
  
        // Mostrar modal
        setOpenErrorImagen(true);
  
        // Limpiar input
        event.target.value = "";
  
        URL.revokeObjectURL(objectUrl);
  
        return;
      }
      */

      // SIN RESTRICCION DE PIXELAJE
      // Aceptamos cualquier dimension

      setFile(selectedFile);

      setImageDimensions({
        width: anchoImagen,
        height: altoImagen,
      });

      setResultadoErrorImagen(null);

      // LIBERAR URL TEMPORAL
      URL.revokeObjectURL(objectUrl);
    };

    // ERROR AL LEER LA IMAGEN
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);

      setFile(undefined);
      setImageDimensions(null);

      setResultadoErrorImagen({
        valido: false,
        titulo: "Imagen no válida",
        mensaje:
          "No fue posible leer la imagen seleccionada. Selecciona un archivo de imagen válido.",
      });

      setOpenErrorImagen(true);

      event.target.value = "";
    };

    img.src = objectUrl;
  };

  const [videoDimensions, setVideoDimensions] = React.useState<{
    width: number;
    height: number;
  } | null>(null);

  const [videoDuration, setVideoDuration] = React.useState<number | null>(null);

  const [resultadoErrorVideo, setResultadoErrorVideo] =
    React.useState<ResultadoValidacionVideo | null>(null);

  const [openErrorVideo, setOpenErrorVideo] = React.useState(false);

  const handleSeleccionarVideo = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {

    const selectedFile =
      event.target.files?.[0];


    if (!selectedFile) {
      return;
    }

    // CREAR VIDEO TEMPORAL

    const video =
      document.createElement("video");

    const objectUrl =
      URL.createObjectURL(selectedFile);
    video.preload = "metadata";

    // LEER METADATA
    video.onloadedmetadata = () => {

      const duracion =
        video.duration;

      // VALIDAR VIDEO
      const resultado =
        validarVideoCompleto(
          selectedFile,
          duracion
        );


      // Liberar URL temporal
      URL.revokeObjectURL(objectUrl);

      // VIDEO INVALIDO
      if (!resultado.valido) {

        setFile(undefined);

        setVideoDuration(null);

        setResultadoErrorVideo(resultado);

        setOpenErrorVideo(true);

        event.target.value = "";

        return;
      }

      // VIDEO VALIDO
      setFile(selectedFile);

      setVideoDuration(duracion);

      setResultadoErrorVideo(null);

    };

    // ERROR AL LEER VIDEO
    video.onerror = () => {

      URL.revokeObjectURL(objectUrl);

      setFile(undefined);

      setVideoDuration(null);

      setResultadoErrorVideo({

        valido: false,

        titulo: "Video no válido",

        mensaje:
          "No fue posible leer el video seleccionado. " +
          "Selecciona un archivo MP4 válido.",

      });


      setOpenErrorVideo(true);

      event.target.value = "";

    };


    video.src = objectUrl;
  };


  // VALIDACIONES CREAR / EDITAR BANNER
  // SOPORTA REGISTRO NORMAL Y REGISTRO MÚLTIPLE

  // Configuración que actualmente se está mostrando
  const formatoActual = registroMultiple
    ? configuracionActual?.formato ?? ""
    : bannerForm.formato;

  const tipoVistaActual = registroMultiple
    ? configuracionActual?.tipoVista ?? ""
    : bannerForm.tipoVista;

  const seccionActual = registroMultiple
    ? configuracionActual?.seccion ?? ""
    : bannerForm.seccion;

  // VALIDAR CAMPOS COMPARTIDOS
  const camposCompartidosCompletos =
    bannerForm.titulo?.trim() !== "" &&
    bannerForm.descripcion?.trim() !== "";

  // VALIDAR CONFIGURACION ACTUAL
  // Esto controla lo que vemos en pantalla
  const camposCargaCompletos =
    tipoAplicacionActual.trim() !== "" &&
    tipoActual.trim() !== "" &&
    tipoVistaActual.trim() !== "" &&
    formatoActual.trim() !== "" &&
    seccionActual.trim() !== "" &&
    camposCompartidosCompletos;

  const configuracionActualCompleta =
    tipoAplicacionActual.trim() !== "" &&
    tipoActual.trim() !== "" &&
    formatoActual.trim() !== "" &&
    tipoVistaActual.trim() !== "" &&
    seccionActual.trim() !== "";

  // FORMATO DEL REGISTRO ACTUAL
  const esFormatoTexto =
    formatoActual.trim().toUpperCase() === "TEXTO" ||
    (
      tipoAplicacionActual.trim().toUpperCase() === "MI CUENTA" &&
      tipoActual.trim().toUpperCase() === "TEXTOS MARQUEE"
    );

  const esFormatoImagen =
    !esFormatoTexto &&
    formatoActual.trim().toUpperCase() === "IMAGEN";

  const esFormatoVideo =
    !esFormatoTexto &&
    formatoActual.trim().toUpperCase() === "VIDEO";


  // VALIDACION NORMAL / EDICION

  const formularioTextoValido =
    esFormatoTexto &&
    camposCargaCompletos;

  const formularioImagenValido =
    esFormatoImagen &&
    camposCargaCompletos &&
    (
      editingBanner
        ? file !== undefined || bannerForm.urlBanner?.trim() !== ""
        : file !== undefined
    );

  const formularioVideoValido =
    esFormatoVideo &&
    camposCargaCompletos &&
    (
      editingBanner
        ? file !== undefined || bannerForm.urlBanner?.trim() !== ""
        : file !== undefined
    );

  const formularioNormalValido =
    esFormatoTexto
      ? formularioTextoValido
      : esFormatoImagen
        ? formularioImagenValido
        : esFormatoVideo
          ? formularioVideoValido
          : false;


  // VALIDACION DE TODOS LOS REGISTROS MULTIPLES
  const configuracionesMultiplesCompletas =
    configuracionesBanner.length > 0 &&
    configuracionesBanner.every((configuracion) => {

      return (
        configuracion.tipoAplicacion?.trim() !== "" &&
        configuracion.tipo?.trim() !== "" &&
        configuracion.formato?.trim() !== "" &&
        configuracion.tipoVista?.trim() !== "" &&
        configuracion.seccion?.trim() !== ""
      );

    });

  // SABER SI ALGUN REGISTRO NECESITA ARCHIVO
  const algunRegistroRequiereArchivo =
    configuracionesBanner.some((configuracion) => {

      const esTexto =
        configuracion.formato?.trim().toUpperCase() === "TEXTO" ||
        (
          configuracion.tipoAplicacion?.trim().toUpperCase() === "MI CUENTA" &&
          configuracion.tipo?.trim().toUpperCase() === "TEXTOS MARQUEE"
        );

      return !esTexto;

    });

  const contieneImagen = configuracionesBanner.some(
    (configuracion) =>
      configuracion.formato?.trim().toUpperCase() === "IMAGEN"
  );

  const contieneVideo = configuracionesBanner.some(
    (configuracion) =>
      configuracion.formato?.trim().toUpperCase() === "VIDEO"
  );

  const mezclaImagenVideo =
    contieneImagen && contieneVideo;

  // VALIDACION FINAL DEL REGISTRO MÚLTIPLE
  const formularioMultipleValido =
    configuracionesMultiplesCompletas &&
    camposCompartidosCompletos &&
    !mezclaImagenVideo &&
    (
      !algunRegistroRequiereArchivo ||
      file !== undefined
    );


  // VALIDACION FINAL DEL BOTON GUARDAR
  const formularioBannerValido =
    registroMultiple && !editingBanner
      ? formularioMultipleValido
      : formularioNormalValido;

  const tiposFiltroDisponibles = React.useMemo(() => {

    if (!vistaFilter) {
      return [];
    }

    return Array.from(
      new Set(
        allData
          .filter(
            (banner) =>
              banner.tipoAplicacion?.trim().toUpperCase() ===
              vistaFilter.trim().toUpperCase()
          )
          .map((banner) => banner.tipo?.trim())
          .filter((tipo): tipo is string => Boolean(tipo))
      )
    );

  }, [allData, vistaFilter]);


  return (

    <Box width="100%" mb={8}>
      <NavBar />
      <IconButton onClick={() => navigate(-1)}>
        <ArrowBackIcon />
      </IconButton>

      <Box px={4}>
        <Typography variant="h4" fontWeight="bold" mb={2}>
          Admin CMS — Banners
        </Typography>

        {puedeVerFiltros && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              mb: 2,
              flexWrap: "wrap",
            }}
          >
            {/* BUSCADOR */}
            <TextField
              size="small"
              placeholder="Buscar por título o descripción..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ minWidth: 250 }}
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setSearchQuery("")}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* FILTRO VISTA */}
            <FormControl
              size="small"
              sx={{ minWidth: 150 }}
              disabled={isLoading}
            >
              <InputLabel>Vista</InputLabel>

              <Select
                value={vistaFilter}
                label="Vista"
                onChange={(e: SelectChangeEvent) => {
                  const nuevaVista = e.target.value;

                  setVistaFilter(nuevaVista);

                  // Al cambiar Vista limpiamos el Tipo seleccionado
                  setTipoFilter("");
                }}
              >
                <MenuItem value="">
                  Todas
                </MenuItem>

                {catalogoVistas.map((vista) => (
                  <MenuItem
                    key={vista.id ?? vista.nombre}
                    value={vista.nombre}
                  >
                    {vista.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* FILTRO FECHA */}
            <FormControl
              size="small"
              sx={{ minWidth: 180 }}
            >
              <InputLabel>Fecha</InputLabel>

              <Select
                value={fechaFilter}
                label="Fecha"
                onChange={(e) => setFechaFilter(e.target.value)}
              >
                <MenuItem value="">Todas</MenuItem>
                <MenuItem value="vigentes">Vigentes</MenuItem>
                <MenuItem value="hoy">Vencen hoy</MenuItem>
                <MenuItem value="vencidos">Vencidos</MenuItem>
                <MenuItem value="sinFecha">Sin fecha</MenuItem>
                <MenuItem value="7dias">Próximos 7 días</MenuItem>
                <MenuItem value="30dias">Próximos 30 días</MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}


        {/* CONTADORES DINÁMICOS POR VISTA */}
        {puedeVerFiltros && vistaFilter && (
          <>
            {contadoresPorTipo.length > 0 ? (

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1.5,
                  mb: 2,
                }}
              >
                {contadoresPorTipo.map(({ tipo, cantidad }) => {

                  const seleccionado = tipoFilter === tipo;

                  return (
                    <Card
                      key={tipo}
                      onClick={() => {
                        if (seleccionado) {
                          setTipoFilter("");
                          return;
                        }

                        setTipoFilter(tipo);
                      }}
                      sx={{
                        minWidth: 140,
                        px: 2,
                        py: 1.5,
                        textAlign: "center",
                        cursor: "pointer",

                        border: seleccionado
                          ? "2px solid"
                          : "1px solid",

                        borderColor: seleccionado
                          ? "secondary.main"
                          : "divider",

                        transition: "0.2s",

                        "&:hover": {
                          boxShadow: 3,
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        color={seleccionado ? "secondary" : "primary"}
                      >
                        {cantidad}
                      </Typography>

                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          mt: 0.5,
                          fontWeight: seleccionado ? 600 : 400,
                        }}
                      >
                        {tipo}
                      </Typography>
                    </Card>
                  );
                })}
              </Box>

            ) : (

              /* NO EXISTEN REGISTROS */
              <Box
                sx={{
                  width: "100%",
                  py: 2,
                  mb: 2,
                  textAlign: "center",
                  border: "1px dashed",
                  borderColor: "divider",
                  borderRadius: 1,
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  No existen registros para la vista{" "}
                  <strong>{vistaFilter}</strong>.
                </Typography>
              </Box>

            )}
          </>
        )}

        {/* TABLA DE BANNERS */}
        {puedeVerTablaBanners && (
          <Box display="flex" gap={3}>
            {/* Tabla de banners */}
            {/*<Card sx={{ flex: previewBanner ? "1 1 60%" : "1 1 100%" }}>*/}

            <Card sx={{ flex: "1 1 100%", position: "relative" }}>
              <CardContent sx={{ position: "relative" }}>

                <MaterialReactTable table={table} />

                <Menu
                  anchorEl={menuAnchorEl}
                  open={Boolean(menuAnchorEl)}
                  onClose={handleCloseMenu}
                >
                  {/* Vista previa */}
                  {puedeVistaPrevia && (
                    <MenuItem
                      onClick={() => {
                        if (!selectedRow) return;

                        setPreviewBanner(selectedRow);
                        setPlatform("web");
                        setOpenPreviewModal(true);

                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                      </ListItemIcon>

                      <ListItemText>Vista previa</ListItemText>
                    </MenuItem>
                  )}

                  {/* Editar */}
                  {puedeEditarBanner && (
                    <MenuItem
                      onClick={() => {
                        if (!selectedRow) return;

                        openEditBanner(selectedRow);

                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        <EditIcon fontSize="small" />
                      </ListItemIcon>

                      <ListItemText>Editar banner</ListItemText>
                    </MenuItem>
                  )}

                  {/* Crear / Editar distribución */}
                  {selectedRow &&
                    (
                      selectedRow.distribuciones?.length
                        ? puedeEditarDistribucion
                        : puedeAgregarDistribucion
                    ) && (
                      <MenuItem
                        onClick={() => {
                          if (!selectedRow) return;

                          if (selectedRow.distribuciones?.length) {
                            // EDITAR DISTRIBUCION
                            openEditDist(
                              selectedRow.id,
                              selectedRow.distribuciones[0]
                            );
                          } else {
                            // CREAR DISTRIBUCION
                            openCreateDist(selectedRow.id);
                          }

                          handleCloseMenu();
                        }}
                      >
                        <ListItemIcon>
                          {selectedRow.distribuciones?.length ? (
                            <EditNoteIcon fontSize="small" />
                          ) : (
                            <AddCircleOutlineIcon fontSize="small" />
                          )}
                        </ListItemIcon>

                        <ListItemText
                          primary={
                            selectedRow.distribuciones?.length
                              ? "Editar distribución"
                              : "Crear distribución"
                          }
                        />
                      </MenuItem>
                    )}

                  {puedeOrdenar &&
                    selectedRow &&
                    (selectedRow.distribuciones?.length ?? 0) > 0 && (
                      <MenuItem
                        onClick={() => {
                          openOrdenamiento(selectedRow);
                        }}
                      >
                        <ListItemIcon>
                          <SettingsIcon fontSize="small" />
                        </ListItemIcon>

                        <ListItemText>
                          Ordenamiento
                        </ListItemText>
                      </MenuItem>
                    )}

                  {puedeEliminarBanner && <Divider />}

                  {/* Eliminar */}
                  {puedeEliminarBanner && (
                    <MenuItem
                      sx={{ color: "error.main" }}
                      onClick={() => {
                        if (!selectedRow) return;

                        handleCloseMenu();
                        handleDeleteBanner(selectedRow.id);
                      }}
                    >
                      <ListItemIcon>
                        <DeleteIcon color="error" fontSize="small" />
                      </ListItemIcon>

                      <ListItemText
                        primary="Eliminar"
                        primaryTypographyProps={{
                          color: "error",
                        }}
                      />
                    </MenuItem>
                  )}
                </Menu>

                {isLoading && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 2,
                      backgroundColor: "rgba(255,255,255,0.65)",
                      zIndex: 1000,
                    }}
                  >
                    <CircularProgress />

                    <Typography variant="body1" fontWeight={500}>
                      Cargando banners...
                    </Typography>
                  </Box>
                )}

              </CardContent>
            </Card>
          </Box>
        )}

      </Box >

      {/* Modal Banner */}
      < Modal open={openBannerDialog} onClose={editingBanner ? handleCloseEditBannerDialog : handleCloseCreateBannerDialog} >
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "95%", maxWidth: 900, maxHeight: "95vh", overflow: "auto", bgcolor: "background.paper", borderRadius: 1, boxShadow: 24, p: 4, "@media (max-width: 900px)": { width: "95%" } }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" fontWeight="bold">
              {editingBanner ? "Editar Banner" : "Crear Banner"}
            </Typography>
            <IconButton disabled={isSaving} onClick={editingBanner ? handleCloseEditBannerDialog : handleCloseCreateBannerDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box display="flex" flexDirection="column" gap={2} mt={2}>
            {!editingBanner && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1.5,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 1,
                }}
              >
                <Box>
                  <Typography fontWeight={600}>
                    Crear múltiples registros
                  </Typography>

                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Permite crear diferentes configuraciones usando
                    la misma información del banner.
                  </Typography>
                </Box>

                <Switch
                  checked={registroMultiple}
                  color="secondary"
                  disabled={isSaving}
                  onChange={(event) => {
                    const activo = event.target.checked;

                    setRegistroMultiple(activo);

                    setConfiguracionesBanner([
                      configuracionBannerVacia(),
                    ]);

                    setIndiceConfiguracion(0);
                  }}
                />

              </Box>
            )}

            {registroMultiple && !editingBanner && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1.5,
                  bgcolor: "action.hover",
                  borderRadius: 1,
                }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={configuracionAnterior}
                  disabled={indiceConfiguracion === 0}
                  sx={{
                    minWidth: 110,
                    textTransform: "none",
                    fontWeight: 600,
                  }}
                >
                  Anterior
                </Button>

                <Box textAlign="center">
                  <Typography fontWeight={600}>
                    Registro {indiceConfiguracion + 1} de{" "}
                    {configuracionesBanner.length}
                  </Typography>

                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Configura los campos de este registro
                  </Typography>
                </Box>

                <Button
                  variant="contained"
                  color="secondary"
                  onClick={configuracionSiguiente}
                  disabled={
                    indiceConfiguracion === configuracionesBanner.length - 1
                  }
                  sx={{
                    minWidth: 110,
                    textTransform: "none",
                    fontWeight: 600,
                  }}
                >
                  Siguiente
                </Button>
              </Box>
            )}
            <Box display="flex" gap={2}>

              <FormControl
                size="small"
                sx={{ flex: 1 }}
                disabled={
                  isSaving ||
                  loadingTiposAplicacion
                }
              >
                <InputLabel>Tipo de Aplicación</InputLabel>

                <Select
                  value={
                    registroMultiple
                      ? configuracionActual?.tipoAplicacion ?? ""
                      : bannerForm.tipoAplicacion
                  }
                  label="Tipo de Aplicación"
                  onChange={(e: SelectChangeEvent) => {
                    const nuevaAplicacion = e.target.value;

                    // REGISTRO MULTIPLE
                    if (registroMultiple) {
                      actualizarConfiguracionActual({
                        tipoAplicacion: nuevaAplicacion,
                        tipo: "",
                        tipoVista: "",
                        seccion: "",
                      });

                      return;
                    }

                    // REGISTRO NORMAL
                    setBannerForm({
                      ...bannerForm,
                      tipoAplicacion: nuevaAplicacion,

                      // Limpiamos los campos dependientes
                      tipo: "",
                      formato: "",
                      tipoVista: "",
                      seccion: "",

                      titulo: "",
                      descripcion: "",
                      urlRedirect: "",
                      urlBanner: "",
                    });

                    setFile(undefined);
                    setImageDimensions(null);
                  }}
                >
                  <MenuItem value="">
                    Selecciona un tipo de aplicación
                  </MenuItem>

                  {catalogoVistas.map((vista) => (
                    <MenuItem
                      key={vista.id ?? vista.nombre}
                      value={vista.nombre}
                    >
                      {vista.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl
                size="small"
                sx={{ flex: 1 }}
                disabled={
                  isSaving ||
                  loadingTipos ||
                  !tipoAplicacionActual
                }
              >
                <InputLabel>Categoria</InputLabel>

                <Select
                  value={
                    tiposDisponibles.some(
                      (tipo) =>
                        tipo.nombre.trim().toUpperCase() ===
                        tipoActual.trim().toUpperCase()
                    )
                      ? tipoActual
                      : ""
                  }
                  label="Tipo"
                  onChange={(e: SelectChangeEvent) => {

                    const nuevoTipo = e.target.value;

                    const esMarquee =
                      tipoAplicacionActual.trim().toUpperCase() === "MI CUENTA" &&
                      nuevoTipo.trim().toUpperCase() === "TEXTOS MARQUEE";

                    if (registroMultiple) {
                      actualizarConfiguracionActual({
                        tipo: nuevoTipo,
                      });

                      return;
                    }

                    setBannerForm({
                      ...bannerForm,
                      tipo: nuevoTipo,
                      titulo: "",
                      formato: esMarquee ? "TEXTO" : "",
                      urlRedirect: esMarquee
                        ? ""
                        : bannerForm.urlRedirect,
                    });
                  }}
                >
                  <MenuItem value="">
                    Selecciona un tipo
                  </MenuItem>
                  {tiposDisponibles.map((tipo) => {
                    const esMarquee =
                      tipo.nombre.trim().toUpperCase() === "TEXTOS MARQUEE";

                    const marqueeIncompatible =
                      registroMultiple &&
                      formatoMaestro.trim() !== "" &&
                      !esFormatoMaestroTexto &&
                      esMarquee;

                    return (
                      <MenuItem
                        key={`${tipo.tipoAplicacion}-${tipo.nombre}`}
                        value={tipo.nombre}
                        disabled={marqueeIncompatible}
                      >
                        {tipo.nombre}
                      </MenuItem>
                    );
                  })}

                </Select>
              </FormControl>

            </Box>
            <FormControl
              size="small"
              fullWidth
              disabled={
                isSaving ||
                loadingFormatos ||
                esTextoMarquee ||
                (registroMultiple && indiceConfiguracion > 0)
              }
            >
              <InputLabel>Formato</InputLabel>

              <Select
                value={
                  esTextoMarquee
                    ? "TEXTO"
                    : registroMultiple
                      ? configuracionActual.formato
                      : bannerForm.formato
                }
                label="Formato"
                onChange={(e: SelectChangeEvent) => {

                  if (registroMultiple) {
                    const nuevoFormato = e.target.value;

                    // El formato solamente puede modificarse desde el Registro 1
                    if (indiceConfiguracion === 0) {
                      setConfiguracionesBanner((prev) =>
                        prev.map((configuracion) => ({
                          ...configuracion,
                          formato: nuevoFormato,
                        }))
                      );

                      setFile(undefined);
                      setImageDimensions(null);
                      setVideoDuration(null);
                    }

                    return;
                  }

                  setBannerForm({
                    ...bannerForm,
                    formato: e.target.value,
                  });
                }}
              >
                {!esTextoMarquee && (
                  <MenuItem value="">
                    Selecciona un formato
                  </MenuItem>
                )}

                {formatosDisponibles.map((formato) => (
                  <MenuItem
                    key={formato.id ?? formato.nombre}
                    value={formato.nombre}
                  >
                    {formato.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/*TIPO DE VISTA*/}

            <FormControl
              size="small"
              fullWidth
              required
              disabled={
                isSaving ||
                loadingTiposVista
              }
            >
              <InputLabel>Tipo de vista</InputLabel>

              <Select
                value={
                  registroMultiple
                    ? configuracionActual.tipoVista
                    : bannerForm.tipoVista
                }
                label="Tipo de vista"
                onChange={(e: SelectChangeEvent) => {

                  if (registroMultiple) {
                    actualizarConfiguracionActual({
                      tipoVista: e.target.value,
                    });

                    return;
                  }

                  setBannerForm({
                    ...bannerForm,
                    tipoVista: e.target.value,
                  });
                }}
              >
                <MenuItem value="">
                  Selecciona un tipo de vista
                </MenuItem>

                {catalogoTiposVista.map((tipoVista) => (
                  <MenuItem
                    key={tipoVista.id ?? tipoVista.nombre}
                    value={tipoVista.nombre}
                  >
                    {tipoVista.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* SECCION */}
            <FormControl
              size="small"
              fullWidth
              required
              disabled={isSaving}
            >
              <InputLabel>Sección</InputLabel>

              <Select
                value={
                  registroMultiple
                    ? configuracionActual.seccion
                    : bannerForm.seccion
                }
                label="Sección"
                onChange={(e: SelectChangeEvent) => {

                  if (registroMultiple) {
                    actualizarConfiguracionActual({
                      seccion: e.target.value,
                    });

                    return;
                  }

                  setBannerForm({
                    ...bannerForm,
                    seccion: e.target.value,
                  });
                }}
              >
                <MenuItem value="">
                  Selecciona una sección
                </MenuItem>

                {CATALOGO_SECCION_BANNER.map((seccion) => (
                  <MenuItem
                    key={seccion}
                    value={seccion}
                  >
                    {seccion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {registroMultiple && configuracionActualCompleta && (
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddIcon />}
                onClick={agregarConfiguracionBanner}
                sx={{
                  mt: 1,
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                Agregar registro
              </Button>
            )}


            {/* <TextField disabled={isSaving} label="Sección" size="small" value={bannerForm.seccion} onChange={(e) => setBannerForm({ ...bannerForm, seccion: e.target.value })} /> 
            <TextField required disabled={isSaving} label="Título" size="small" value={bannerForm.titulo} onChange={(e) => setBannerForm({ ...bannerForm, titulo: e.target.value })} /> */}
            {esTextoMarquee ? (

              // TITULO PARA TEXTOS MARQUEE
              <FormControl
                size="small"
                fullWidth
                required
                disabled={
                  isSaving ||
                  loadingTitulosMarquee
                }
              >
                <InputLabel>Título</InputLabel>

                <Select
                  value={bannerForm.titulo}
                  label="Título"
                  onChange={(e: SelectChangeEvent) =>
                    setBannerForm({
                      ...bannerForm,
                      titulo: e.target.value,
                    })
                  }
                >
                  <MenuItem value="">
                    Selecciona un título
                  </MenuItem>

                  {catalogoTitulosMarquee.map((titulo) => (
                    <MenuItem
                      key={titulo.id ?? titulo.nombre}
                      value={titulo.nombre}
                    >
                      {titulo.nombre}
                    </MenuItem>
                  ))}

                </Select>
              </FormControl>



            ) : (

              // TITULO NORMAL

              <TextField
                required
                disabled={isSaving}
                label="Título"
                size="small"
                value={bannerForm.titulo}
                onChange={(e) =>
                  setBannerForm({
                    ...bannerForm,
                    titulo: e.target.value,
                  })
                }
              />

            )}

            <TextField required disabled={isSaving} label="Descripción" size="small" multiline rows={2} value={bannerForm.descripcion} onChange={(e) => setBannerForm({ ...bannerForm, descripcion: e.target.value })} />
            {!esFormatoTexto && (
              <TextField
                disabled={isSaving}
                label="URL Redirect"
                size="small"
                value={bannerForm.urlRedirect}
                onChange={(e) =>
                  setBannerForm({
                    ...bannerForm,
                    urlRedirect: e.target.value,
                  })
                }
              />
            )}
            {/*  <TextField disabled={isSaving} label="URL Redirect" size="small" value={bannerForm.urlRedirect} onChange={(e) => setBannerForm({ ...bannerForm, urlRedirect: e.target.value })} />
            <FormControlLabel disabled={isSaving} control={<Switch checked={bannerForm.activo} onChange={(e) => setBannerForm({ ...bannerForm, activo: e.target.checked })} />} label="Activo" />*/}
            <Box
              display="flex"
              gap={2}
              alignItems="center"
            >

              {/* FORMATO IMAGEN */}

              {esFormatoImagen && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2,
                    width: "100%",
                  }}
                >

                  {/* VISTA PREVIA */}
                  {(file || bannerForm.urlBanner) && (
                    <Box
                      sx={{
                        width: "60%",
                        maxWidth: 500,
                        borderRadius: 1,
                        overflow: "hidden",
                        border: "1px solid #ddd",
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <img
                        src={
                          file
                            ? URL.createObjectURL(file)
                            : bannerForm.urlBanner
                        }
                        alt="Vista previa"
                        style={{
                          width: "100%",
                          maxHeight: "250px",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </Box>
                  )}

                  {/* BOTON SUBIR / CAMBIAR IMAGEN */}
                  {camposCargaCompletos && (
                    <Button
                      component="label"
                      variant="contained"
                      color="secondary"
                      startIcon={<CloudUploadIcon />}
                      disabled={isSaving}
                      sx={{
                        minWidth: 210,
                        height: 44,
                        mt: file || bannerForm.urlBanner ? 0 : 1,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {file || bannerForm.urlBanner
                        ? "CAMBIAR IMAGEN"
                        : "SUBIR IMAGEN"}

                      <VisuallyHiddenInput
                        type="file"
                        accept="image/*"
                        onChange={handleSeleccionarImagen}
                      />
                    </Button>
                  )}

                </Box>
              )}


              {/*FORMATO VIDEO*/}
              {esFormatoVideo && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2,
                    width: "100%",
                  }}
                >

                  {/* VISTA PREVIA DEL VIDEO */}

                  {(file || bannerForm.urlBanner) && (
                    <Box
                      sx={{
                        width: "60%",
                        maxWidth: 500,
                        borderRadius: 1,
                        overflow: "hidden",
                        border: "1px solid #ddd",
                        backgroundColor: "#000",
                      }}
                    >
                      <video
                        key={
                          file
                            ? file.name
                            : bannerForm.urlBanner
                        }
                        src={
                          file
                            ? URL.createObjectURL(file)
                            : bannerForm.urlBanner
                        }
                        controls
                        preload="metadata"
                        style={{
                          width: "100%",
                          maxHeight: "280px",
                          display: "block",
                          objectFit: "contain",
                        }}
                      >
                        Tu navegador no soporta reproducción de video.
                      </video>
                    </Box>
                  )}

                  {/* BOTON + INFORMACION */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >

                    {/* BOTON */}

                    <Button
                      component="label"
                      disabled={
                        isSaving ||
                        !camposCargaCompletos
                      }
                      variant="contained"
                      color="secondary"
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        width: "fit-content",
                        minWidth: "auto",
                      }}
                    >
                      {file || bannerForm.urlBanner
                        ? "CAMBIAR VIDEO"
                        : "SUBIR VIDEO"}

                      <VisuallyHiddenInput
                        disabled={
                          isSaving ||
                          !camposCargaCompletos
                        }
                        type="file"
                        accept=".mp4,video/mp4"
                        onChange={handleSeleccionarVideo}
                      />

                    </Button>

                    {/* INFORMACION DEL VIDEO */}
                    {file && videoDuration !== null && (
                      <Box
                        sx={{
                          mt: 0.5,
                          px: 1,
                        }}
                      >

                        <Typography
                          variant="body2"
                          fontWeight={600}
                        >
                          Información del video
                        </Typography>

                        <Typography
                          variant="caption"
                          display="block"
                          color="text.secondary"
                        >
                          Formato: MP4
                        </Typography>

                        <Typography
                          variant="caption"
                          display="block"
                          color="text.secondary"
                        >
                          Peso: {(file.size / (1024 * 1024)).toFixed(2)} MB
                        </Typography>

                        <Typography
                          variant="caption"
                          display="block"
                          color="text.secondary"
                        >
                          Duración: {videoDuration.toFixed(1)} segundos
                        </Typography>

                      </Box>
                    )}

                  </Box>

                </Box>
              )}

            </Box>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleSaveBanner}
              disabled={
                isSaving ||
                !formularioBannerValido
              }
            >
              {isSaving
                ? "Guardando..."
                : editingBanner
                  ? "Actualizar"
                  : "Guardar"}
            </Button>
          </Box>
        </Box>
      </Modal >
      {/*MODALES*/}


      < VistaPreviaBanner
        open={openPreviewModal}
        previewBanner={previewBanner}
        platform={platform}
        setPlatform={setPlatform}
        onClose={() => {
          setOpenPreviewModal(false);
          setPreviewBanner(null);
        }}
      />
      < ModalErroresImagenes
        open={openErrorImagen}
        resultado={resultadoErrorImagen}
        onClose={() => {
          setOpenErrorImagen(false);
          setResultadoErrorImagen(null);
        }}
      />
      < ModalErroresVideos
        open={openErrorVideo}
        resultado={resultadoErrorVideo}
        onClose={() => {
          setOpenErrorVideo(false);
          setResultadoErrorVideo(null);
        }}
      />
      {/* Modal Distribución */}
      <Modal open={openDistDialog} onClose={isSaving ? undefined : handleCloseDistDialog}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "80%", maxWidth: 700, maxHeight: "90vh", overflow: "auto", bgcolor: "background.paper", borderRadius: 1, boxShadow: 24, p: 4, "@media (max-width: 900px)": { width: "95%" } }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" fontWeight="bold">
              {editingDist ? "Editar Distribución" : "Crear Distribución"}
            </Typography>
            <IconButton disabled={isSaving} onClick={handleCloseDistDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box display="flex" flexDirection="column" gap={2} mt={2}>
            <FormControl size="small">
              <InputLabel>Empresa</InputLabel>
              <Select disabled={isSaving} value={distForm.idEmpresa?.toString() || ""} label="Empresa" onChange={(e: SelectChangeEvent) => setDistForm({ ...distForm, idEmpresa: e.target.value ? Number(e.target.value) : null })}>
                <MenuItem value="">Todas</MenuItem>
                {empresas.map((e) => <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>)}
              </Select>
            </FormControl>
            {/*
            <Box display="flex" gap={2}>
              <FormControl disabled={isSaving} size="small" sx={{ flex: 1 }}>
                <InputLabel>Región</InputLabel>
                <Select value={distForm.idRegion?.toString() || ""} label="Región" onChange={(e: SelectChangeEvent) => setDistForm({ ...distForm, idRegion: e.target.value ? Number(e.target.value) : null })}>
                  <MenuItem value="">Todas</MenuItem>
                  {regiones.map((r) => <MenuItem key={r.id} value={r.id}>{r.nombre}</MenuItem>)}
                </Select>
              </FormControl>
              <FormControl disabled={isSaving} size="small" sx={{ flex: 1 }}>
                <InputLabel>Estado</InputLabel>
                <Select value={distForm.idEstado?.toString() || ""} label="Estado" onChange={(e: SelectChangeEvent) => setDistForm({ ...distForm, idEstado: e.target.value ? Number(e.target.value) : null })}>
                  <MenuItem value="">Todos</MenuItem>
                  {estados.map((e) => <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>)}
                </Select>
              </FormControl>
            </Box>
            <FormControl disabled={isSaving} size="small">
              <InputLabel>Puesto</InputLabel>
              <Select value={distForm.idPuesto?.toString() || ""} label="Puesto" onChange={(e: SelectChangeEvent) => setDistForm({ ...distForm, idPuesto: e.target.value ? Number(e.target.value) : null })}>
                <MenuItem value="">Todos</MenuItem>
                {puestos.map((p) => <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl disabled={isSaving} size="small">
              <InputLabel>Empleado</InputLabel>
              <Select value={distForm.externo === null ? "" : distForm.externo ? "1" : "0"} label="Empleado" onChange={(e: SelectChangeEvent) => setDistForm({ ...distForm, externo: e.target.value === "" ? null : e.target.value === "1" })}>
                <MenuItem value="">Interno y Externo</MenuItem>
                <MenuItem value="0">Solo Interno</MenuItem>
                <MenuItem value="1">Solo Externo</MenuItem>
              </Select>
            </FormControl>
            */}
            <Box display="flex" gap={2}>
              <TextField size="small" type="datetime-local" label="Fecha Inicio" InputLabelProps={{ shrink: true }}
                value={distForm.fechaInicio} onChange={(e) => {
                  const nuevaFechaInicio = e.target.value;
                  if (
                    distForm.fechaFin && new Date(nuevaFechaInicio) >= new Date(distForm.fechaFin)
                  ) {
                    swal({
                      title: "Fecha inválida",
                      text: "La fecha de inicio debe ser anterior a la fecha de fin.",
                      icon: "error",
                    });
                    return;
                  }
                  setDistForm({ ...distForm, fechaInicio: nuevaFechaInicio, });
                }}
              />
              <TextField size="small" type="datetime-local" label="Fecha Fin"
                InputLabelProps={{ shrink: true }}
                value={distForm.fechaFin}
                onChange={(e) => {
                  const nuevaFechaFin = e.target.value;

                  if (
                    distForm.fechaInicio && new Date(nuevaFechaFin) <= new Date(distForm.fechaInicio)
                  ) {
                    swal({
                      title: "Fecha inválida",
                      text: "La fecha de fin debe ser posterior a la fecha de inicio.",
                      icon: "error",
                    });
                    return;
                  }
                  setDistForm({ ...distForm, fechaFin: nuevaFechaFin, });
                }}
              />
            </Box>
            {/* <TextField disabled={isSaving} size="small" type="number" label="Orden" value={distForm.orden} onChange={(e) => setDistForm({ ...distForm, orden: Number(e.target.value) })} />*/}

            {/*<FormControl
              fullWidth
              size="small"
              disabled={isSaving}
            >
              <InputLabel id="orden-distribucion-label">
                Orden
              </InputLabel>

              <Select
                labelId="orden-distribucion-label"
                label="Orden"
                value={distForm.orden}
                onChange={(e) =>
                  setDistForm({
                    ...distForm,
                    orden: Number(e.target.value),
                  })
                }
              >
                {CATALOGO_ORDEN_DISTRIBUCION.map((orden) => (
                  <MenuItem
                    key={orden}
                    value={orden}
                  >
                    {orden}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            */}
            <FormControlLabel disabled={isSaving} control={<Switch checked={distForm.redirectWeb} onChange={(e) => setDistForm({ ...distForm, redirectWeb: e.target.checked })} />} label="Activar redirect web" />
            <Button variant="contained" color="secondary" onClick={handleSaveDist} disabled={isSaving || !isDistFormValid}>
              {isSaving ? "Guardando..." : (editingDist ? "Actualizar" : "Guardar")}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* MODAL ORDENAMIENTO */}

      <Modal
        open={openOrdenamientoDialog}
        onClose={handleCloseOrdenamiento}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            width: {
              xs: "95%",
              sm: "90%",
              md: 900,
            },

            maxHeight: "85vh",
            overflowY: "auto",

            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          {/* ENCABEZADO */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography
              variant="h6"
              fontWeight={700}
            >
              Ordenamiento de banners
            </Typography>

            <IconButton
              onClick={handleCloseOrdenamiento}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />

          {/*IFORMACION DEL FLUJO*/}

          {bannerOrdenamiento && (
            <Box
              sx={{
                bgcolor: "#f5f5f5",
                borderRadius: 2,
                p: 2,
                mb: 3,
              }}
            >
              <Typography
                fontWeight={700}
                mb={2}
              >
                Configuración del flujo
              </Typography>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                    md: "repeat(5, 1fr)",
                  },
                  gap: 2,
                }}
              >
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Tipo de aplicación
                  </Typography>

                  <Typography fontWeight={600}>
                    {bannerOrdenamiento.tipoAplicacion || "-"}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Categoría
                  </Typography>

                  <Typography fontWeight={600}>
                    {bannerOrdenamiento.tipo || "-"}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Formato
                  </Typography>

                  <Typography fontWeight={600}>
                    {bannerOrdenamiento.formato || "-"}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Tipo de vista
                  </Typography>

                  <Typography fontWeight={600}>
                    {bannerOrdenamiento.tipoVista || "-"}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    Sección
                  </Typography>

                  <Typography fontWeight={600}>
                    {bannerOrdenamiento.seccion || "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          {/*ORDENAMIENTOS EXISTENTES*/}

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography fontWeight={700}>
              Ordenamientos existentes
            </Typography>
            {/*
            <FormControlLabel
              control={
                <Switch
                  checked={modoIntercambioOrden}
                  disabled={isSaving}
                  color="secondary"
                  onChange={(event) => {
                    const activo = event.target.checked;

                    setModoIntercambioOrden(activo);

                    // Cada vez que cambia el modo
                    // limpiamos selecciones anteriores.
                    setDistribucionesSeleccionadas([]);
                  }}
                />
              }
              label="Intercambiar orden"
            />
            */}
          </Box>

          {/* ORDENES DISPONIBLES */}
          {!modoIntercambioOrden && (
            <Box
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                bgcolor: "#f5f5f5",
              }}
            >
              <Typography
                variant="body2"
                fontWeight={600}
                mb={1}
              >
                Ordenes disponibles
              </Typography>

              {ordenesDisponibles.length > 0 ? (
                <Box
                  display="flex"
                  gap={1}
                  flexWrap="wrap"
                >
                  {ordenesDisponibles.map((orden) => {
                    return (
                      <Chip
                        key={orden}
                        label={orden}
                        color="secondary"
                        variant="outlined"
                        size="small"
                      />
                    );
                  })}
                </Box>
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  No existen órdenes disponibles.
                  Utiliza "Intercambiar orden".
                </Typography>
              )}
            </Box>
          )}

          {ordenamientosExistentes.length === 0 ? (

            <Box
              sx={{
                p: 3,
                textAlign: "center",
                bgcolor: "#f5f5f5",
                borderRadius: 2,
              }}
            >
              <Typography color="text.secondary">
                No existen distribuciones para este flujo.
              </Typography>
            </Box>

          ) : (

            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              {/* CABECERA */}

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: modoIntercambioOrden
                    ? "45px 140px 1fr 85px 105px 105px"
                    : "140px 1fr 85px 105px 105px",
                  gap: 1,
                  px: 1.5,
                  py: 1.2,
                  alignItems: "center",
                  bgcolor: "#f5f5f5",
                  fontWeight: 600,
                }}
              >
                {modoIntercambioOrden && (
                  <Typography variant="body2" fontWeight={600}>
                    Seleccionar
                  </Typography>
                )}

                <Typography variant="body2" fontWeight={600}>
                  Orden
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  Título
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  Vista previa
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  Fecha inicio
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  Fecha fin
                </Typography>
              </Box>

              {/* REGISTROS */}

              {itemsOrdenamiento.map((item, index) => {

                const tieneOrden =
                  item.orden !== null &&
                  item.orden !== undefined &&
                  Number(item.orden) > 0;

                // IDENTIFICAR EL REGISTRO SELECCIONADO
                const esBannerAbierto =
                  item.bannerId === bannerOrdenamiento?.id;

                return (
                  <Box
                    key={`${item.bannerId}-${item.distribucionId}`}

                    // DRAG AND DROP
                    draggable={
                      !isSaving &&
                      tieneOrden
                    }

                    onDragStart={(event) => {
                      if (!tieneOrden) {
                        event.preventDefault();
                        return;
                      }

                      setIndiceArrastrado(index);
                    }}

                    onDragOver={(event) => {
                      if (!tieneOrden) {
                        return;
                      }

                      event.preventDefault();
                    }}

                    onDrop={async (event) => {
                      event.preventDefault();

                      // NO PERMITIR SOLTAR SOBRE
                      // UN REGISTRO SIN ORDEN
                      if (!tieneOrden) {
                        setIndiceArrastrado(null);
                        return;
                      }

                      if (
                        indiceArrastrado === null ||
                        indiceArrastrado === index
                      ) {
                        setIndiceArrastrado(null);
                        return;
                      }

                      // 1. REORDENAR VISUALMENTE
                      const nuevosItems = moverItemOrdenamiento(
                        indiceArrastrado,
                        index
                      );

                      setIndiceArrastrado(null);

                      // 2. OBTENER LOS REGISTROS QUE CAMBIARON
                      const cambios =
                        obtenerCambiosOrdenamiento(nuevosItems);

                      console.log(
                        "CAMBIOS DE ORDEN:",
                        cambios
                      );

                      if (cambios.length === 0) {
                        return;
                      }

                      // 3. PEDIR CONFIRMACION
                      const confirmar = await swal({
                        title: "Confirmar cambio de orden",
                        text: "¿Deseas guardar el nuevo orden de los banners?",
                        icon: "warning",
                        buttons: ["Cancelar", "Aceptar"],
                      });

                      // 4. SI CANCELA, REGRESAR AL ORDEN ORIGINAL
                      if (!confirmar) {
                        setItemsOrdenamiento(
                          itemsOrdenamientoGuardados
                        );

                        return;
                      }

                      // 5. SI ACEPTA, GUARDAR EN BACKEND
                      await guardarCambiosOrdenamiento(cambios);
                    }}

                    onDragEnd={() => {
                      setIndiceArrastrado(null);
                    }}

                    sx={{
                      display: "grid",

                      gridTemplateColumns: modoIntercambioOrden
                        ? "45px 140px 1fr 85px 105px 105px"
                        : "140px 1fr 85px 105px 105px",

                      gap: 1,
                      p: 1.5,
                      alignItems: "center",

                      borderTop: "1px solid #eee",

                      // RESALTAR REGISTRO ABIERTO
                      backgroundColor: esBannerAbierto
                        ? "#e8f5e9"
                        : "transparent",

                      borderLeft: esBannerAbierto
                        ? "4px solid #2e7d32"
                        : "4px solid transparent",

                      // DRAG AND DROP
                      cursor: isSaving
                        ? "default"
                        : tieneOrden
                          ? "grab"
                          : "default",

                      opacity:
                        indiceArrastrado === index
                          ? 0.5
                          : 1,

                      transition:
                        "background-color 0.2s ease, opacity 0.2s ease",
                    }}
                  >
                    {/* CHECKBOX SOLO EN MODO INTERCAMBIO */}
                    {modoIntercambioOrden && (
                      <Checkbox
                        checked={distribucionesSeleccionadas.includes(
                          item.distribucionId
                        )}
                        disabled={
                          isSaving ||
                          (
                            distribucionesSeleccionadas.length >= 2 &&
                            !distribucionesSeleccionadas.includes(
                              item.distribucionId
                            )
                          )
                        }
                        onChange={() =>
                          handleSeleccionarDistribucionOrden(
                            item.distribucionId
                          )
                        }
                        color="secondary"
                      />
                    )}
                    {/* ORDEN */}
                    {item.orden !== null &&
                      item.orden !== undefined &&
                      Number(item.orden) > 0 ? (
                      <Chip
                        label={item.orden}
                        size="small"
                        color="secondary"
                        sx={{
                          width: 50,
                          fontWeight: 700,
                        }}
                      />
                    ) : (
                      <FormControl
                        size="small"
                        sx={{
                          width: "100%",
                          maxWidth: 125,
                        }}
                      >
                        <Select
                          value=""
                          displayEmpty
                          disabled={
                            isSaving ||
                            ordenesDisponibles.length === 0
                          }
                          onChange={(event) => {
                            const nuevoOrden = Number(
                              event.target.value
                            );

                            if (!nuevoOrden) {
                              return;
                            }

                            handleAsignarOrden(
                              item,
                              nuevoOrden
                            );
                          }}
                          sx={{
                            height: 32,
                            fontSize: 13,
                          }}
                        >
                          <MenuItem value="" disabled>
                            Seleccionar
                          </MenuItem>

                          {ordenesDisponibles.map((orden) => (
                            <MenuItem
                              key={orden}
                              value={orden}
                            >
                              Orden {orden}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {/* TITULO */}
                    <Typography>
                      {item.titulo || "-"}
                    </Typography>

                    {/* VISTA PREVIA */}
                    {item.formato?.trim().toUpperCase() === "TEXTO" ||
                      !item.urlBanner ? (
                      <Box
                        sx={{
                          width: 80,
                          height: 50,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          -
                        </Typography>
                      </Box>
                    ) : item.formato?.trim().toUpperCase() === "VIDEO" ? (
                      <video
                        src={item.urlBanner}
                        muted
                        playsInline
                        preload="metadata"
                        onLoadedMetadata={(e: React.SyntheticEvent<HTMLVideoElement>) => {
                          const video = e.currentTarget;

                          if (video.duration > 0) {
                            video.currentTime = Math.min(
                              0.1,
                              video.duration
                            );
                          }
                        }}
                        style={{
                          width: 80,
                          height: 50,
                          objectFit: "cover",
                          borderRadius: 4,
                          border: "1px solid #ddd",
                          display: "block",
                        }}
                      />
                    ) : (
                      <Box
                        component="img"
                        src={item.urlBanner}
                        alt={item.titulo || "Banner"}
                        sx={{
                          width: 80,
                          height: 50,
                          objectFit: "cover",
                          borderRadius: 1,
                          border: "1px solid #ddd",
                          display: "block",
                        }}
                        onError={(e) => {
                          (
                            e.target as HTMLImageElement
                          ).style.display = "none";
                        }}
                      />
                    )}

                    {/* FECHA INICIO */}
                    <Typography variant="body2">
                      {item.fechaInicio
                        ? new Date(
                          item.fechaInicio
                        ).toLocaleString("es-MX")
                        : "-"}
                    </Typography>

                    {/* FECHA FIN */}
                    <Typography variant="body2">
                      {item.fechaFin
                        ? new Date(
                          item.fechaFin
                        ).toLocaleString("es-MX")
                        : "-"}
                    </Typography>
                  </Box>
                );
              })}

            </Box>
          )}

          {distribucionesSeleccionadas.length === 2 && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={
                isSaving
                  ? <CircularProgress size={18} color="inherit" />
                  : <SettingsIcon />
              }
              onClick={handleIntercambiarOrden}
              disabled={
                isSaving ||
                distribucionesSeleccionadas.length !== 2
              }
            >
              {isSaving
                ? "Intercambiando..."
                : "Intercambiar orden"}
            </Button>
          )}

          {/* BOTON CERRAR */}

          <Box
            display="flex"
            justifyContent="flex-end"
            mt={3}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={handleCloseOrdenamiento}
              disabled={isSaving}
            >
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>

    </Box >
  );
};

export default CmsAdmin;
